
import React, { useState } from "react";
import MenuGraph from "./MenuGraph";
import DoughnutGraph from "./DoughnutGraph";
import AreaGraph from "./AreaGraph";
import PieGraph from "./PieGraph";
import LineGraph from "./LineGraph";
import ReactSpeedometer from "./Speedometer";
import ReactSpeedometerss from "./Speedometer";
import { MultiGraph } from "./MultiGraph";
import { MultiLineGraph } from "./MulitLineGraph";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CampaignIcon from "@mui/icons-material/Campaign";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { Link } from "react-router-dom";
import DateRangePickerr from "./DateRangePicker";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import WalletIcon from "@mui/icons-material/Wallet";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import Swal from "sweetalert2";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Icon,
  IconButton,
  Popover,
  Skeleton,
} from "@mui/material";
import DoughnutGraph1 from "./DoughnutGraph1";
import PieGraph1 from "./PieGraph1";
import { useDispatch, useSelector } from "react-redux";
import ForwardIcon from "@mui/icons-material/Forward";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { common_axios } from "../../../App";
import ProgressBar from "./ProgressBar";
import moment from "moment";
import PieChartTest from "./PieChartTest";
import UserProgressBar from "./UserProgressBar";
import Counter from "./Counter";
import CircularStatic from "./CircularStatic";
import { useRef } from "react";
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfYear,
  startOfMonth,
  endOfMonth,
  endOfYear,
  addMonths,
  subMonths,
  addYears,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
} from "date-fns";
import {
  setTimeSeries,
  setTimeSeries1,
  setTimeSeries2,
} from "../../../redux/features/dashboardSlice";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import * as XLSX from "xlsx";

export default function Dashboard({ history }) {
  const [anchorEll, setAnchorEll] = React.useState(null);

  const selectedTime = useSelector(
    (state) => state.dashboardReducer.timeSeries
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (selectedTime?.dateType == "Daily") {
      seDataTime({
        ...dataTime,
        graph1: selectedTime?.dateType,
        line1: selectedTime?.dateType,
      });
    }
  }, [selectedTime?.buttonClicked]);

  var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();
  var firstDay = new Date(y, m, 1);
  var lastDay = new Date(y, m + 1, 0);

  firstDay = moment(firstDay).format("YYYYMM");
  lastDay = moment(lastDay).format("YYYYMM");
  let firstDay0 = moment(new Date(y, m, 1)).format("YYYY-MM-DD");
  let lastDay0 = moment(new Date(y, m + 1, 0)).format("YYYY-MM-DD");

  var date1 = new Date(moment(new Date()).add(-1, "months")),
    y1 = date1.getFullYear(),
    m1 = date1.getMonth();
  var firstDay1 = new Date(y1, m1, 1);
  var lastDay1 = new Date(y1, m1 + 1, 0);

  firstDay1 = moment(firstDay1).format("YYYYMM");
  lastDay1 = moment(lastDay1).format("YYYYMM");
  let firstDay11 = moment(new Date(y1, m1, 1)).format("YYYY-MM-DD");
  let lastDay11 = moment(new Date(y1, m1 + 1, 0)).format("YYYY-MM-DD");

  const currentMonth = moment().format("MM");
  const currentYear = moment().format("YYYY");

  const [data, setData] = useState(null);
  const [data1, setData1] = useState(null);
  const [data2, setData2] = useState(null);
  const [data3, setData3] = useState(null);
  const [data4, setData4] = useState(null);
  const [data5, setData5] = useState(null);
  const [open, setOpen] = useState(null);
  const [open1, setOpen1] = useState(null);
  const [open2, setOpen2] = useState(null);
  const [open3, setOpen3] = useState(null);
  const [open4, setOpen4] = useState(null);
  const [open5, setOpen5] = useState(null);
  const [data6, setData6] = useState(null);
  const [open6, setOpen6] = useState(null);
  const [timeSeries2State, setTimeSeries2State] = useState(undefined);
  const resd = useSelector((data) => data?.dashboardReducer);
  var date = moment(new Date());
  var now = moment(firstDay);
  var duration = moment.duration(date.diff(now));
  var noofDays = duration.asDays();
  const [dataTime, seDataTime] = useState({
    graph1: "Daily",
    line1: "Daily",
    pie1: null,
    pie2: null,
    pie3: null,
    pie4: null,
    tabs: localStorage.getItem("dashboardTopTabs")
      ? localStorage.getItem("dashboardTopTabs")
      : 3,
    dateTabs0: {
      name: "1M",
      enddateValue: moment().format("YYYY-MM-DD"),
      startdateValue: moment(addDays(new Date(), -29)).format("YYYY-MM-DD"),
      dateTypee: "Month",
      startDateMonth: moment(startOfMonth(addMonths(new Date(), -1))).format(
        "YYYYMM"
      ),
      endDateMonth: moment().format("YYYYMM"),
      tooltipText: "1 Month",
    },
    dateTabs1: {
      name: "1M",
      enddateValue: moment().format("YYYY-MM-DD"),
      startdateValue: moment(addDays(new Date(), -29)).format("YYYY-MM-DD"),
      dateTypee: "Month",
      startDateMonth: moment(startOfMonth(addMonths(new Date(), -1))).format(
        "YYYYMM"
      ),
      endDateMonth: moment().format("YYYYMM"),
      tooltipText: "1 Month",
    },
  });
//  console.log("kkoii", dataTime.tabs);
  const fetchUserr = async () => {
    try {
      setOpen(true);

      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v2/get/All/Cards/data`,
        {
          dashBoardRequest: {
            flag:
              dataTime.tabs == 0
                ? "Previous Month"
                : dataTime.tabs == 3
                ? "Today"
                : dataTime.tabs == 4
                ? "Yesterday"
                : "Current Month",
            monthCode:
              dataTime.tabs == 0
                ? firstDay1
                : dataTime.tabs == 3
                ? null
                : dataTime.tabs == 4
                ? null
                : firstDay,
            dailyCode:
              dataTime.tabs == 0
                ? null
                : dataTime.tabs == 3
                ? moment().format("YYYY-MM-DD")
                : dataTime.tabs == 4
                ? moment().add(-1, "day").format("YYYY-MM-DD")
                : null,
          },
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
        }
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        if (res?.data?.cardResponse) setData(res.data?.cardResponse);
        setOpen(false);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  const fetchPerformance = async () => {
    try {
      setOpen1(true);
      localStorage.removeItem("counterViewed");
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/All/performance`,
        {
          campaignRequest: {
            startDateTime: dataTime?.dateTabs1?.startDateMonth
              ? dataTime?.dateTabs1?.endDateMonth
              : dataTime?.dateTabs1?.enddateValue,
            endDateTime: dataTime?.dateTabs1?.startDateMonth
              ? dataTime?.dateTabs1?.startDateMonth
              : dataTime?.dateTabs1?.startdateValue,
          },
          flag: dataTime?.dateTabs1?.dateTypee,
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
        }
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        if (res?.data?.performanceResponse)
          setData1(res.data?.performanceResponse);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } finally {
      setOpen1(false);
    }
  };
  const fetchPerformanceBreakdown = async () => {
    try {
      setOpen2(true);
      localStorage.removeItem("counterViewed");
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/All/break-down/performance`,
        {
          campaignRequest: {
            startDateTime: dataTime?.dateTabs1?.startDateMonth
              ? dataTime?.dateTabs1?.endDateMonth
              : dataTime?.dateTabs1?.enddateValue,
            endDateTime: dataTime?.dateTabs1?.startDateMonth
              ? dataTime?.dateTabs1?.startDateMonth
              : dataTime?.dateTabs1?.startdateValue,
          },
          flag: dataTime?.dateTabs1?.dateTypee,
          role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
        }
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        if (res?.data?.performanceResponse)
          setData2(res.data?.performanceResponse);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } finally {
      setOpen2(false);
    }
  };
  const fetchSenderIdAndTemplate = async () => {
    try {
      setOpen3(true);
      localStorage.removeItem("counterViewed");
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/All/cards/approve-pending/senderId-template`
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        if (res?.data?.cardResponse) setData3(res.data?.cardResponse);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } finally {
      setOpen3(false);
    }
  };
  const fetchBlackOutDetails = async () => {
    try {
      setOpen5(true);
      localStorage.removeItem("counterViewed");
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/black-out`
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        if (res?.data?.blackOutModel) setData5(res.data?.blackOutModel);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } finally {
      setOpen5(false);
    }
  };
  const fetchSystemTps = async () => {
    try {
      setOpen4(true);
      localStorage.removeItem("counterViewed");
      const res = await common_axios(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/
admin/v1/get/system-tps`
      );

      if (res.data?.statusDescription?.statusCode == 200) {
        if (res?.data?.systemTpsModel) setData4(res.data?.systemTpsModel);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } finally {
      setOpen4(false);
    }
  };
  const fetchMiddleCards = async () => {
    try {
      setOpen3(true);
      localStorage.removeItem("counterViewed");
      let res, res1, res2;

      res1 = common_axios(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/All/cards/approve-pending/senderId-template`
      );

      if (
        JSON.parse(localStorage.getItem("Sidebaritems"))?.name ===
        "ROLE_SUPER_ADMIN"
      ) {
        res = common_axios(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/system-tps`
        );

        res2 = common_axios(
          `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/black-out`
        );
      }

      let arr =
        JSON.parse(localStorage.getItem("Sidebaritems"))?.name ===
        "ROLE_SUPER_ADMIN"
          ? [res, res1, res2]
          : [res1];
      // console.log("kj",arr)
      await Promise.allSettled(arr).then((result) => {
        // console.log({ result });
        if (
          result?.[0]?.status === "fulfilled" &&
          result?.[0]?.value?.data?.statusDescription?.statusCode === 200
        ) {
          if (result?.[0]?.value?.data?.systemTpsModel) {
            setData4(result?.[0]?.value?.data?.systemTpsModel);
          }
        }
        if (result.length == 1) {
          if (
            result?.[0]?.status === "fulfilled" &&
            result?.[0]?.value?.data?.statusDescription?.statusCode === 200
          ) {
            if (result?.[0]?.value?.data?.cardResponse) {
              setData3(result?.[0]?.value?.data?.cardResponse);
            }
          }
        } else {
          if (
            result?.[1]?.status === "fulfilled" &&
            result?.[1]?.value?.data?.statusDescription?.statusCode === 200
          ) {
            if (result?.[1]?.value?.data?.cardResponse) {
              setData3(result?.[1]?.value?.data?.cardResponse);
            }
          }
        }

        if (
          result?.[2]?.status === "fulfilled" &&
          result?.[2]?.value?.data?.statusDescription?.statusCode === 200
        ) {
          if (result?.[2]?.value?.data?.blackOutModel) {
            setData5(result?.[2]?.value?.data?.blackOutModel);
          }
        }
      });
    } catch (error) {
      // console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } finally {
      setOpen3(false);
    }
  };

  // const fetchTopSenderId = async () => {
  //   try {
  //     setOpen3(true);
  //     localStorage.removeItem("counterViewed");
  //     const res = await common_axios.post(
  //       `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/top-5/senderId`,
  //       {
  //         campaignRequest: {
  //           startDateTime: "2023-06-26",
  //           endDateTime: "2023-06-01",
  //         },
  //       }
  //     );

  //     if (res.data?.statusDescription?.statusCode == 200) {
  //       if (res?.data?.cardResponse) setData3(res.data?.cardResponse);
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: res.data.statusDescription.statusMessage,
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }
  //   } catch (error) {
  //     // console.log(error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Something went wrong",
  //       // footer: '<a href="">Why do I have this issue?</a>'
  //     });
  //   } finally {
  //     setOpen3(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchTopSenderId();
  // }, [selectedTime?.start, selectedTime?.end]);

  useEffect(() => {
    fetchPerformance();
    fetchPerformanceBreakdown();
  }, [dataTime.dateTabs1]);

  useEffect(() => {
    setAnchorEll(null);
  }, [selectedTime?.buttonClicked]);
  useEffect(() => {
    fetchUserr();
  }, [dataTime?.tabs]);

  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const rect = ref.current.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
    setIsVisible(isVisible);
  };

  useEffect(() => {
    // fetchSenderIdAndTemplate();
    const options = {
      passive: true,
    };
    fetchMiddleCards();
    // if (
    //   JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
    //   "ROLE_SUPER_ADMIN"
    // ) {
    //   fetchSystemTps();
    //   fetchBlackOutDetails();
    // }

    window.addEventListener("scroll", handleScroll, options);

    return () => {
      window.removeEventListener("scroll", handleScroll, options);
    };
  }, []);

  useEffect(() => {
    dispatch(
      setTimeSeries({
        start: dataTime.dateTabs0.startdateValue,
        end: dataTime.dateTabs0.enddateValue,
        dateType: dataTime.dateTabs0?.dateTypee,
        buttonClicked: false,
      })
    );
  }, [dataTime.dateTabs0]);

  async function topSenderData() {
    // setTableLoader(true);
    //
    try {
      setOpen6(true);
      // setScheduleSkelton(true);
      // sethideSkeleton(true)
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/top-5/senderId`,
        {
          campaignRequest: {
            startDateTime: resd?.timeSeries?.end,
            endDateTime: resd?.timeSeries?.start,
          },
        }
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        if (result?.data?.top5SenderIdAndUsers) {
          result.data.top5SenderIdAndUsers[0].total =
            result?.data?.top5SenderIdAndUsers?.reduce(
              (partialSum, a) => {
                return partialSum + a.total_Sms_Count;
              },

              0
            );

          setData6(result?.data?.top5SenderIdAndUsers);
        }
      } else if (result.data.statusDescription.statusCode == 220) {
        setData6([]);
      } else {
        // setScheduleSkelton(false);
        // sethideSkeleton(false)
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } finally {
      setOpen6(false);
    }
    // console.log("response..", res);
  }

  useEffect(() => {
    topSenderData();
  }, [resd?.timeSeries?.end, resd?.timeSeries?.start]);

  useEffect(() => {
    localStorage.setItem("dashboardTopTabs", "3");
  }, []);

  useEffect(() => {
    if (timeSeries2State != undefined) {
      localStorage.setItem("TimeSeries2", JSON.stringify(timeSeries2State));
    }
  }, [timeSeries2State]);
  // ..........................................................................................//
  const [ViewTableForm, setViewTableForm] = React.useState(false);
  const [anchorEl4, setAnchorEl4] = React.useState(null);
  const openmenue4 = Boolean(anchorEl4);
  const downloadRef_revenuecost = useRef(null);

  const [isFullScreen, setFullScreen] = useState(false);

  // console.log("dh8", isFullScreen);

  const downloadRef_revenuecost_child = useRef(null);
  const [RevenueCostData, setRevenueCostData] = useState(null);
  const handleClosemenue4 = () => {
    setAnchorEl4(null);
  };
  const handleClickmenue4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };
  // const handleClosemenue = () => {
  //   setAnchorEl(null);
  // };

  const enterFullScreen = () => {
    handleClosemenue4();
    const element = document.getElementById("revenucostgraphFull");
    if (element) {
      if (element.requestFullscreen) {
        element
          .requestFullscreen()
          .then(() => setFullScreen(true))
          .catch((error) => console.log("Error entering full-screen:", error));
      } else if (element.webkitRequestFullscreen) {
        // Safari
        element
          .webkitRequestFullscreen()
          .then(() => setFullScreen(true))
          .catch((error) => console.log("Error entering full-screen:", error));
      } else if (element.msRequestFullscreen) {
        // Internet Explorer
        element
          .msRequestFullscreen()
          .then(() => setFullScreen(true))
          .catch((error) => console.log("Error entering full-screen:", error));
      } else {
        setFullScreen(false);
      }
    }
  };

  const downloadChartAsPDF_revenucostDATA = async () => {
    handleClosemenue4();
    const element = downloadRef_revenuecost.current;
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = 190;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);

      pdf.save("SuccessGraph.pdf");
    });
  };

  const downloadChartAsPDF_revenucostDATA_forTable = async () => {
    //  for img
    setOpen(true);
    handleClosemenue4();
    const element = downloadRef_revenuecost_child.current;

    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", [320, 500]);
      const pdfWidth = 300;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      if (pdf) {
        setOpen(false);
      }

      pdf.addImage(imgData, "PNG", 20, 20, pdfWidth, pdfHeight);
      pdf.save("Revenue & Cost.pdf");
    });
  };

  const exitFullScreen = () => {
    handleClosemenue4();
    if (document.exitFullscreen) {
      document
        .exitFullscreen()
        .then(() => setFullScreen(false))
        .catch((error) => console.log("Error exiting full-screen:", error));
    } else if (document.webkitExitFullscreen) {
      // Safari
      document
        .webkitExitFullscreen()
        .then(() => setFullScreen(false))
        .catch((error) => console.log("Error exiting full-screen:", error));
    } else if (document.msExitFullscreen) {
      // Internet Explorer
      document
        .msExitFullscreen()
        .then(() => setFullScreen(false))
        .catch((error) => console.log("Error exiting full-screen:", error));
    } else {
      setFullScreen(false);
    }
  };

  const handleClickExcel_revenucostDATA = () => {
    // Create workbook and worksheet
    handleClosemenue4();

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet([]);

    // Set headers
    const headers = ["Date", ...data.datasets.map((series) => series.label)];
    XLSX.utils.sheet_add_json(worksheet, [headers], { skipHeader: true });

    // Set data
    const rows = data.labels.map((xAxis, index) => {
      const rowData = [
        xAxis,
        ...data.datasets.map((series) => series.data[index]),
      ];
      return rowData;
    });
    XLSX.utils.sheet_add_json(worksheet, rows, {
      skipHeader: true,
      origin: "A2",
    });

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Generate the Excel file

    XLSX.writeFile(workbook, "FailedGraph.xlsx");
  };
  // const lastDateOfMonth = moment().endOf('month').format("YYYY-MM-DD");
  // console.log("fiqqrst",lastDateOfMonth)
  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <div className="home-section home_section p-4">
        <div className="card mb-3">
          <div className="card-header pb-0 p-3 pt-2">
            <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={
                    dataTime.tabs == 3
                      ? `nav-link ms-4  position-relative active`
                      : `nav-link ms-4  position-relative `
                  }
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    localStorage.setItem("dashboardTopTabs", 3);
                    seDataTime({
                      ...dataTime,
                      tabs: 3,
                    });
                  }}
                >
                  Today
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={
                    dataTime.tabs == 4
                      ? `nav-link ms-4  position-relative active`
                      : `nav-link ms-4  position-relative `
                  }
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    localStorage.setItem("dashboardTopTabs", 4);
                    seDataTime({
                      ...dataTime,
                      tabs: 4,
                    });
                  }}
                >
                  Yesterday
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={
                    dataTime.tabs == 1
                      ? `nav-link ms-4  position-relative active`
                      : `nav-link ms-4  position-relative `
                  }
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                  onClick={() => {
                    localStorage.setItem("dashboardTopTabs", 1);
                    seDataTime({
                      ...dataTime,
                      tabs: 1,
                    });
                  }}
                >
                  Current Month
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={
                    dataTime.tabs == 0
                      ? `nav-link ms-4  position-relative active`
                      : `nav-link ms-4  position-relative `
                  }
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                  onClick={() => {
                    localStorage.setItem("dashboardTopTabs", 0);
                    seDataTime({
                      ...dataTime,
                      tabs: 0,
                    });
                  }}
                >
                  Previous Month
                </button>
              </li>
            </ul>
          </div>

          <div className="card-body">
            {open ? (
              <>
                <div className="row  my-2">
                  <div className="col-md-3">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={82}
                    />
                  </div>
                  <div className="col-md-3">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={82}
                    />
                  </div>
                  <div className="col-md-3">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={82}
                    />
                  </div>
                  <div className="col-md-3">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={82}
                    />
                  </div>
                </div>

                <div className="row mb-2 mt-4">
                  <div className="col-md-3">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={82}
                    />
                  </div>
                  <div className="col-md-3">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={82}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div class="row" id="card_8">
                  <div
                    class="col-xl-3 col-md-6 my-3"
                    onClick={() => {
                      // if (dataTime.tabs == 0) {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Approved,campaign,${firstDay11},${lastDay11}`
                      //   );
                      // } else {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Approved,campaign,${firstDay0},${lastDay0}`
                      //   );
                      // }

                      localStorage?.setItem(
                        "dstQueCode1",
                        `Completed,campaign,${
                          dataTime.tabs == 0
                            ? firstDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : moment(
                                startOfMonth(addMonths(new Date(), -1))
                              ).format("YYYY-MM-DD")
                        },${
                          dataTime.tabs == 0
                            ? lastDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD")
                        }`
                      );

                      dispatch(
                        setTimeSeries1({
                          end:
                            dataTime.tabs == 0
                              ? lastDay11
                              : dataTime.tabs == 3
                              ? moment().format("YYYY-MM-DD")
                              : dataTime.tabs == 4
                              ? moment().add(-1, "day").format("YYYY-MM-DD")
                              : moment().add(-2, "days").format("YYYY-MM-DD"),
                          start:
                            dataTime.tabs == 0
                              ? firstDay11
                              : dataTime.tabs == 3
                              ? moment().format("YYYY-MM-DD")
                              : dataTime.tabs == 4
                              ? moment().add(-1, "day").format("YYYY-MM-DD")
                              : moment(startOfMonth(new Date())).format(
                                  "YYYY-MM-DD"
                                ),
                          dateType: "Daily",
                          approveType: "Completed",
                        })
                      );
                      document
                        .getElementsByName("sidebarLiReports")?.[0]
                        ?.click();

                      // history?.push("/dashboard/TransactionalReport");
                      if (dataTime?.tabs == 3 || dataTime?.tabs == 4) {
                        history?.push("/dashboard/48HourReport");
                      } else {
                        history?.push("/dashboard/TransactionalReport");
                      }
                    }}
                  >
                    <div class="card card_1">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            check_circle_icon
                          </Icon>
                        </div>
                        <div>
                          <h3>
                            {data?.totalCampaign?.toLocaleString("en-US")
                              ? data?.totalCampaign?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                          <span>Completed Campaigns</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-md-6 my-3"
                    onClick={() => {
                      localStorage?.setItem(
                        "dstQueCode1",
                        `Stopped,campaign,${
                          dataTime.tabs == 0
                            ? firstDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : moment(
                                startOfMonth(addMonths(new Date(), -1))
                              ).format("YYYY-MM-DD")
                        },${
                          dataTime.tabs == 0
                            ? lastDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD")
                        }`
                      );

                      dispatch(
                        setTimeSeries1({
                          end:
                            dataTime.tabs == 0
                              ? lastDay11
                              : dataTime.tabs == 3
                              ? moment().format("YYYY-MM-DD")
                              : dataTime.tabs == 4
                              ? moment().add(-1, "day").format("YYYY-MM-DD")
                              : moment().add(-2, "days").format("YYYY-MM-DD"),
                          start:
                            dataTime.tabs == 0
                              ? firstDay11
                              : dataTime.tabs == 3
                              ? moment().format("YYYY-MM-DD")
                              : dataTime.tabs == 4
                              ? moment().add(-1, "day").format("YYYY-MM-DD")
                              : moment(startOfMonth(new Date())).format(
                                  "YYYY-MM-DD"
                                ),
                          dateType: "Daily",
                          approveType: "Failed",
                        })
                      );
                      document
                        .getElementsByName("sidebarLiReports")?.[0]
                        ?.click();
                      // history?.push("/dashboard/TransactionalReport");
                      if (dataTime?.tabs == 3 || dataTime?.tabs == 4) {
                        history?.push("/dashboard/48HourReport");
                      } else {
                        history?.push("/dashboard/TransactionalReport");
                      }
                    }}
                  >
                    <div class="card card_2">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon component="i">cancel_schedule_send_icon</Icon>
                        </div>
                        <div>
                          <h3>
                            {data?.failedCampaign?.toLocaleString("en-US")
                              ? data?.failedCampaign?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                          <span>Failed Campaigns</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-md-6 my-3"
                    onClick={async () => {
                      // if (dataTime.tabs == 0) {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Approved,successM,${firstDay1},${lastDay1}`
                      //   );
                      // } else {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Approved,successM,${firstDay},${lastDay}`
                      //   );
                      // }

                      localStorage?.setItem(
                        "dstQueCode1",
                        `Approved,successM,${
                          dataTime.tabs == 0
                            ? firstDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : firstDay0
                        },${
                          dataTime.tabs == 0
                            ? lastDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : lastDay0
                        }`
                      );

                      // history?.push("/dashboard/DashboardReportss");

                      // if(dataTime?.tabs==3 || dataTime?.tabs==4){
                      //   history?.push("/dashboard/DashboardReportss");
                      // }else{
                      //   history?.push("/dashboard/SuccessGraph");
                      // }
                      if (dataTime.tabs == 3) {
                        await setTimeSeries2State({
                          end: moment(new Date()).format("YYYY-MM-DD"),
                          // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                          start: moment(new Date()).format("YYYY-MM-DD"),
                          dateType: "Month",
                          buttonClicked: false,
                          approveType: "Completed",
                        });
                        dispatch(
                          setTimeSeries2({
                            end: moment(new Date()).format("YYYY-MM-DD"),
                            // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                            start: moment(new Date()).format("YYYY-MM-DD"),
                            dateType: "Month",
                            buttonClicked: false,
                            approveType: "Completed",
                            // start: "",
                            // end: "",
                          })
                        );
                      } else if (dataTime.tabs == 4) {
                        await setTimeSeries2State({
                          end: moment(new Date())
                            .subtract("days", 1)
                            .format("YYYY-MM-DD"),
                          // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                          start: moment(new Date())
                            .subtract("days", 1)
                            .format("YYYY-MM-DD"),
                          dateType: "Month",
                          buttonClicked: false,
                          approveType: "Completed",
                        });
                        dispatch(
                          setTimeSeries2({
                            end: moment(new Date())
                              .subtract("days", 1)
                              .format("YYYY-MM-DD"),
                            // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                            start: moment(new Date())
                              .subtract("days", 1)
                              .format("YYYY-MM-DD"),
                            dateType: "Month",
                            buttonClicked: false,
                            approveType: "Completed",
                            // start: "",
                            // end: "",
                          })
                        );
                      } else if (dataTime.tabs == 1) {
                        await setTimeSeries2State({
                          end: moment(new Date()).format("YYYY-MM-DD"),

                          start: `${currentYear}-${currentMonth}-01`,
                          dateType: "Month",
                          buttonClicked: false,
                          approveType: "Completed",
                        });
                        dispatch(
                          setTimeSeries2({
                            end: moment(new Date()).format("YYYY-MM-DD"),

                            start: `${currentYear}-${currentMonth}-01`,
                            dateType: "Month",
                            buttonClicked: false,
                            approveType: "Completed",
                          })
                        );
                      } else if (dataTime.tabs == 0) {
                        await setTimeSeries2State({
                          end: moment(new Date())
                            .subtract("days", 1)
                            .format("YYYY-MM-DD"),
                          // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                          start: moment(new Date())
                            .subtract("days", 1)
                            .format("YYYY-MM-DD"),
                          dateType: "Month",
                          buttonClicked: false,
                          approveType: "Completed",
                        });
                        dispatch(
                          setTimeSeries2({
                            // end: moment(new Date())
                            //   .subtract("days", 1)
                            //   .format("YYYY-MM-DD"),


end:moment().endOf('month').subtract("months",1).format("YYYY-MM-DD") ,

                            // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),


start: `${moment(new Date()).subtract("months",1).format("YYYY-MM")}-01`,

                            // start: moment(new Date())
                            //   .subtract("days", 1)
                            //   .format("YYYY-MM-DD"),
                            dateType: "Month",
                            buttonClicked: false,
                            approveType: "Completed",
                            // start: "",
                            // end: "",
                          })
                        );
                      }
                      history?.push("/dashboard/SuccessGraph");
                    }}
                  >
                    <div class="card card_1">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            mark_email_read_icon
                          </Icon>
                        </div>
                        <div>
                          <h3>
                            {data?.totalSuccessMessage?.toLocaleString("en-US")
                              ? data?.totalSuccessMessage?.toLocaleString(
                                  "en-US"
                                )
                              : "0"}
                          </h3>
                          <span>Success Messages</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-md-6 my-3"
                    onClick={async () => {
                      // if (dataTime.tabs == 0) {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Approved,failedM,${firstDay1},${lastDay1}`
                      //   );
                      // } else {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Approved,failedM,${firstDay},${lastDay}`
                      //   );
                      // }

                      localStorage?.setItem(
                        "dstQueCode1",
                        `Approved,failedM,${
                          dataTime.tabs == 0
                            ? firstDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : firstDay0
                        },${
                          dataTime.tabs == 0
                            ? lastDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : lastDay0
                        }`
                      );
                     


                        if (dataTime.tabs == 3) {
                        await setTimeSeries2State({
                          end: moment(new Date()).format("YYYY-MM-DD"),
                          // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                          start: moment(new Date()).format("YYYY-MM-DD"),
                          dateType: "Month",
                          buttonClicked: false,
                          approveType: "Completed",
                        });                                  
                        dispatch(
                          setTimeSeries2({
                            end: moment(new Date()).format("YYYY-MM-DD"),
                            // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                            start: moment(new Date()).format("YYYY-MM-DD"),
                            dateType: "Month",
                            buttonClicked: false,
                            approveType: "Completed",
                            // start: "",
                            // end: "",
                          })
                        );
                      } else if (dataTime.tabs == 4) {
                        await setTimeSeries2State({
                          end: moment(new Date())
                            .subtract("days", 1)
                            .format("YYYY-MM-DD"),
                          // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                          start: moment(new Date())
                            .subtract("days", 1)
                            .format("YYYY-MM-DD"),
                          dateType: "Month",
                          buttonClicked: false,
                          approveType: "Completed",
                        });
                        dispatch(
                          setTimeSeries2({
                            end: moment(new Date())
                              .subtract("days", 1)
                              .format("YYYY-MM-DD"),
                            // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                            start: moment(new Date())
                              .subtract("days", 1)
                              .format("YYYY-MM-DD"),
                            dateType: "Month",
                            buttonClicked: false,
                            approveType: "Completed",
                            // start: "",
                            // end: "",
                          })
                        );
                      } else if (dataTime.tabs == 1) {
                        await setTimeSeries2State({
                          end: moment(new Date()).format("YYYY-MM-DD"),

                          start: `${currentYear}-${currentMonth}-01`,
                          dateType: "Month",
                          buttonClicked: false,
                          approveType: "Completed",
                        });
                        dispatch(
                          setTimeSeries2({
                            end: moment(new Date()).format("YYYY-MM-DD"),

                            start: `${currentYear}-${currentMonth}-01`,
                            dateType: "Month",
                            buttonClicked: false,
                            approveType: "Completed",
                          })
                        );
                      } else if (dataTime.tabs == 0) {
                        await setTimeSeries2State({
                          end: moment(new Date())
                            .subtract("days", 1)
                            .format("YYYY-MM-DD"),
                          // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                          start: moment(new Date())
                            .subtract("days", 1)
                            .format("YYYY-MM-DD"),
                          dateType: "Month",
                          buttonClicked: false,
                          approveType: "Completed",
                        });
                        dispatch(
                          setTimeSeries2({
                            // end: moment(new Date())
                            //   .subtract("days", 1)
                            //   .format("YYYY-MM-DD"),


end:moment().endOf('month').subtract("months",1).format("YYYY-MM-DD") ,

                            // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),


start: `${moment(new Date()).subtract("months",1).format("YYYY-MM")}-01`,

                            // start: moment(new Date())
                            //   .subtract("days", 1)
                            //   .format("YYYY-MM-DD"),
                            dateType: "Month",
                            buttonClicked: false,
                            approveType: "Completed",
                            // start: "",
                            // end: "",
                          })
                        );
                      }
                        // dispatch(
                        //   setTimeSeries2({
                        //     end: moment(new Date()).format("YYYY-MM-DD"),
                        //     // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

                        //     start: moment(new Date()).format("YYYY-MM-DD"),
                        //     dateType: "Month",
                        //     buttonClicked: false,
                        //     approveType: "Completed",
                        //     // start: "",
                        //     // end: "",
                        //   })
                        // );
                      
                      // history?.push("/dashboard/DashboardReportss");
                      // history?.push("/dashboard/FailedGraph");

                      // if(dataTime?.tabs==3 || dataTime?.tabs==4){
                      //   history?.push("/dashboard/DashboardReportss");
                      // }else{
                      //   history?.push("/dashboard/FailedGraph");
                      // }

                      history?.push("/dashboard/FailedGraph");
                    }}
                  >
                    <div class="card card_2">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            sms_failed_icon
                          </Icon>
                        </div>
                        <div>
                          <h3>
                            {data?.totalFailMessage?.toLocaleString("en-US")
                              ? data?.totalFailMessage?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                          <span>Failed Messages</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div
                    class="col-xl-3 col-md-6 my-3"
                    onClick={() => {
                      if (dataTime.tabs == 0) {
                        localStorage?.setItem(
                          "dstQueCode1",
                          `Success,recharge,${firstDay1},${lastDay1}`
                        );
                      } else {
                        localStorage?.setItem(
                          "dstQueCode1",
                          `Success,recharge,${firstDay},${lastDay}`
                        );
                      }

                      history?.push("/dashboard/Dashboardreports");
                    }}
                  >
                    <div class="card card_1">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            account_balance_icon
                          </Icon>
                        </div>
                        <div>
                          <h3> {data?.recharges ? data?.recharges : "0"}</h3>
                          <span>Success Recharges</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div class="row" id="card_8">
                  <div class="col-xl-3 col-md-6 my-3">
                    <div class="card card_1">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            check_circle_icon
                          </Icon>
                        </div>
                        <div>
                          <h3>
                            {data?.totalCreditUtilization?.toLocaleString(
                              "en-US"
                            )
                              ? data?.totalCreditUtilization?.toLocaleString(
                                  "en-US"
                                )
                              : "0"}
                          </h3>
                          <span>Credit Utilized</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-md-6 my-3"
                    onClick={() => {
                      document
                        .getElementsByName("sidebarLiReports")?.[0]
                        ?.click();
                      history?.push("/dashboard/RechargeReport");
                    }}
                  >
                    <div class="card card_2">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            cancel_schedule_send_icon
                          </Icon>
                        </div>
                        <div>
                          <h3>
                            {data?.totalRecharges?.toLocaleString("en-US")
                              ? data?.totalRecharges?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                          <span>Recharge Amount</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div
                    class="col-xl-3 col-md-6 my-3"
                    onClick={() => {
                      if (dataTime.tabs == 0) {
                        localStorage?.setItem(
                          "dstQueCode1",
                          `Success,recharge,${firstDay1},${lastDay1}`
                        );
                      } else {
                        localStorage?.setItem(
                          "dstQueCode1",
                          `Success,recharge,${firstDay},${lastDay}`
                        );
                      }

                      history?.push("/dashboard/Dashboardreports");
                    }}
                  >
                    <div class="card card_1">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            account_balance_icon
                          </Icon>
                        </div>
                        <div>
                          <h3> {data?.recharges ? data?.recharges : "0"}</h3>
                          <span>Success Recharges</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </>
            )}
          </div>
        </div>

        {open3 ||
        (data3?.pendingSenderId && data3?.pendingSenderId !== 0) ||
        (data3?.pendingTemplate && data3?.pendingTemplate !== 0) ||
        (data3?.senderIds && data3?.senderIds !== 0) ||
        (data3?.templates && data3?.templates !== 0) ? (
          <div className="card mb-3">
            <div className="card-body">
              {open3 ? (
                <>
                  <div className="row my-2">
                    <div className="col-xl-3 col-md-6">
                      <Skeleton
                        variant="rectangular"
                        sx={{
                          borderRadius: "0px 30px 0px 30px !important",
                        }}
                        width={"100%"}
                        height={182}
                      />
                    </div>
                    <div className="col-xl-3 col-md-6">
                      <Skeleton
                        variant="rectangular"
                        sx={{
                          borderRadius: "0px 30px 0px 30px !important",
                        }}
                        width={"100%"}
                        height={182}
                      />
                    </div>
                    {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                    "ROLE_SUPER_ADMIN" ? (
                      <>
                        <div className="col-xl-3 col-md-6">
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              borderRadius: "0px 30px 0px 30px !important",
                            }}
                            width={"100%"}
                            height={182}
                          />
                        </div>
                        <div className="col-xl-3 col-md-6">
                          <Skeleton
                            variant="rectangular"
                            sx={{
                              borderRadius: "0px 30px 0px 30px !important",
                            }}
                            width={"100%"}
                            height={182}
                          />
                        </div>
                      </>
                    ) : null}
                    {/* <div className="col-md-3">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={82}
                    />
                  </div>
                  <div className="col-md-3">
                    <Skeleton
                      variant="rectangular"
                      width={"100%"}
                      height={82}
                    />
                  </div> */}
                  </div>
                </>
              ) : (
                <>
                  <div class="row justify-content-start" id="card_8">
                    {(data3?.pendingSenderId && data3?.pendingSenderId !== 0) ||
                    (data3?.pendingTemplate && data3?.pendingTemplate !== 0) ? (
                      <div
                        class="col-xl-3 col-md-6 my-3"
                        // onClick={() => {
                        //   // if (dataTime.tabs == 0) {
                        //   //   localStorage?.setItem(
                        //   //     "dstQueCode1",
                        //   //     `Approved,sender-id,${firstDay1},${lastDay1}`
                        //   //   );
                        //   // } else {
                        //   //   localStorage?.setItem(
                        //   //     "dstQueCode1",
                        //   //     `Approved,sender-id,${firstDay},${lastDay}`
                        //   //   );
                        //   // }

                        //   localStorage?.setItem(
                        //     "dstQueCode1",
                        //     `Approved,sender-id,${
                        //       dataTime.tabs == 0
                        //         ? firstDay11
                        //         : dataTime.tabs == 3
                        //         ? moment().format("YYYY-MM-DD")
                        //         : dataTime.tabs == 4
                        //         ? moment().add(-1, "day").format("YYYY-MM-DD")
                        //         : firstDay0
                        //     },${
                        //       dataTime.tabs == 0
                        //         ? lastDay11
                        //         : dataTime.tabs == 3
                        //         ? moment().format("YYYY-MM-DD")
                        //         : dataTime.tabs == 4
                        //         ? moment().add(-1, "day").format("YYYY-MM-DD")
                        //         : lastDay0
                        //     }`
                        //   );

                        //   history?.push("/dashboard/Dashboardreports");
                        // }}
                      >
                        <div
                          class="card card_1 card_border_radius "
                          style={{
                            background:
                              "linear-gradient(21deg, rgba(255,139,0,1) 0%, rgba(255,166,60,1) 35%, rgba(255,255,255,1) 100%)",
                            cursor: "default",
                          }}
                        >
                          <div class="text-center d-flex justify-content-center ">
                            <div className="my-auto">
                              <h1 className="fs-4 my-auto ">Pending</h1>
                              {JSON.parse(localStorage.getItem("Sidebaritems"))
                                ?.name == "ROLE_SUPER_ADMIN" ? (
                                <span
                                  classname="mt-1 text-black"
                                  id="blinkSpan"
                                >
                                  (Action Required)
                                </span>
                              ) : null}
                            </div>
                            <div
                              class="div_i8  ms-3"
                              style={{
                                backgroundColor: "rgb(255 120 0 / 25%)",
                              }}
                            >
                              <Icon
                                className="icon2_color_UP"
                                // class="d-block"
                                component="i"
                              >
                                watch_later_icon
                              </Icon>
                            </div>

                            {/* <div>
                          <h3>
                            {data3?.senderIds?.toLocaleString("en-US")
                              ? data3?.senderIds?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                         
                        </div> */}
                          </div>
                          <div className="mt-2">
                            <table class="table mb-0">
                              <tbody>
                                <div
                                  className="border_transparent_up headingCard_up2 my-2"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    localStorage.setItem(
                                      "senderIdRedirectToken",
                                      "0"
                                    );
                                    if (
                                      JSON.parse(
                                        localStorage.getItem("Sidebaritems")
                                      )?.name == "ROLE_SUPER_ADMIN"
                                    ) {
                                      document
                                        .getElementsByName(
                                          "sidebarLiApproval"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/SenderId");
                                    } else {
                                      document
                                        .getElementsByName(
                                          "sidebarLiSenderId Management"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/MySenderId");
                                    }
                                  }}
                                >
                                  <th scope="row" className="d-flex gap-2">
                                    <Icon className="text-white" component="i">
                                      contact_phone_icon
                                    </Icon>
                                    <span className="">Sender Id</span>
                                  </th>
                                  <td>{data3?.pendingSenderId}</td>
                                </div>

                                <div
                                  className="border_transparent_up headingCard_up2 my-2"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    localStorage.setItem(
                                      "templateRedirectToken",
                                      "0"
                                    );
                                    if (
                                      JSON.parse(
                                        localStorage.getItem("Sidebaritems")
                                      )?.name == "ROLE_SUPER_ADMIN"
                                    ) {
                                      document
                                        .getElementsByName(
                                          "sidebarLiApproval"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/Template");
                                    } else {
                                      document
                                        .getElementsByName(
                                          "sidebarLiTemplate Management"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/MyTemplate");
                                    }
                                  }}
                                >
                                  <th scope="row" className="d-flex gap-2">
                                    <Icon
                                      className="text-white"
                                      // class="d-block"
                                      component="i"
                                    >
                                      newspaper_icon
                                    </Icon>
                                    <span className="">Template</span>
                                  </th>
                                  <td>{data3?.pendingTemplate}</td>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {(data3?.senderIds && data3?.senderIds !== 0) ||
                    (data3?.templates && data3?.templates !== 0) ? (
                      <div
                        class="col-xl-3 col-md-6 my-3"
                        // onClick={() => {
                        //   // if (dataTime.tabs == 0) {
                        //   //   localStorage?.setItem(
                        //   //     "dstQueCode1",
                        //   //     `Approved,sender-id,${firstDay1},${lastDay1}`
                        //   //   );
                        //   // } else {
                        //   //   localStorage?.setItem(
                        //   //     "dstQueCode1",
                        //   //     `Approved,sender-id,${firstDay},${lastDay}`
                        //   //   );
                        //   // }

                        //   localStorage?.setItem(
                        //     "dstQueCode1",
                        //     `Approved,sender-id,${
                        //       dataTime.tabs == 0
                        //         ? firstDay11
                        //         : dataTime.tabs == 3
                        //         ? moment().format("YYYY-MM-DD")
                        //         : dataTime.tabs == 4
                        //         ? moment().add(-1, "day").format("YYYY-MM-DD")
                        //         : firstDay0
                        //     },${
                        //       dataTime.tabs == 0
                        //         ? lastDay11
                        //         : dataTime.tabs == 3
                        //         ? moment().format("YYYY-MM-DD")
                        //         : dataTime.tabs == 4
                        //         ? moment().add(-1, "day").format("YYYY-MM-DD")
                        //         : lastDay0
                        //     }`
                        //   );

                        //   history?.push("/dashboard/Dashboardreports");
                        // }}
                      >
                        <div
                          class="card bg_bg_card card_border_radius"
                          style={{
                            cursor: "default",
                          }}
                        >
                          <div class="text-center d-flex justify-content-center ">
                            <div className="my-auto">
                              <h1 className="fs-4 my-auto"> All Approved</h1>
                            </div>
                            <div class="div_i8 ms-3 card_icon_UP">
                              <Icon
                                // class="d-block"
                                component="i"
                              >
                                check_circle_icon
                              </Icon>
                            </div>

                            {/* <div>
                          <h3>
                            {data3?.senderIds?.toLocaleString("en-US")
                              ? data3?.senderIds?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                         
                        </div> */}
                          </div>
                          <div className="mt-2">
                            <table class="table mb-0">
                              <tbody>
                                <div
                                  className="border_transparent_up headingCard_up my-2"
                                  onClick={() => {
                                    if (
                                      JSON.parse(
                                        localStorage.getItem("Sidebaritems")
                                      )?.name == "ROLE_SUPER_ADMIN"
                                    ) {
                                      document
                                        .getElementsByName(
                                          "sidebarLiApproval"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/SenderId");
                                    } else {
                                      document
                                        .getElementsByName(
                                          "sidebarLiSenderId Management"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/MySenderId");
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <th scope="row" className="d-flex gap-2">
                                    <Icon
                                      className="text-white"
                                      // class="d-block"
                                      component="i"
                                    >
                                      contact_phone_icon
                                    </Icon>

                                    <span className="">Sender Id</span>
                                  </th>
                                  <td>{data3?.senderIds}</td>
                                </div>

                                <div
                                  className="border_transparent_up headingCard_up my-2"
                                  onClick={() => {
                                    if (
                                      JSON.parse(
                                        localStorage.getItem("Sidebaritems")
                                      )?.name == "ROLE_SUPER_ADMIN"
                                    ) {
                                      document
                                        .getElementsByName(
                                          "sidebarLiApproval"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/Template");
                                    } else {
                                      document
                                        .getElementsByName(
                                          "sidebarLiTemplate Management"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/MyTemplate");
                                    }
                                  }}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  <th scope="row" className="d-flex gap-2">
                                    <Icon
                                      className="text-white"
                                      // class="d-block"
                                      component="i"
                                    >
                                      newspaper_icon
                                    </Icon>
                                    <span classname="">Template</span>
                                  </th>

                                  <td>{data3?.templates}</td>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                    "ROLE_SUPER_ADMIN" ? (
                      <>
                        {(data5?.endTime && data5?.endTime !== 0) ||
                        (data5?.startTime && data5?.startTime !== 0) ? (
                          <div class="col-xl-3 col-md-6 my-3">
                            <div
                              class="card card_1 card_border_radius "
                              style={{
                                background:
                                  "linear-gradient(21deg, rgb(56 83 235 / 81%) 0%, rgb(164 159 219 / 66%) 35%, rgb(255, 255, 255) 100%)",
                                cursor: "default",
                              }}
                            >
                              <div class="text-center d-flex justify-content-center ">
                                <div className="my-auto">
                                  <h1 className="fs-4 my-auto ">Black Out</h1>
                                </div>
                                <div
                                  class="div_i8  ms-3"
                                  style={{
                                    backgroundColor: "rgb(89 92 224 / 26%)",
                                  }}
                                >
                                  <Icon
                                    sx={{
                                      color: "rgb(89 92 224) !important",
                                    }}
                                    className="icon2_color_UP"
                                    // class="d-block"
                                    component="i"
                                  >
                                    notifications_off_icon
                                  </Icon>
                                </div>

                                {/* <div>
                          <h3>
                            {data3?.senderIds?.toLocaleString("en-US")
                              ? data3?.senderIds?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                         
                        </div> */}
                              </div>
                              <div className="mt-2">
                                <table class="table mb-0">
                                  <tbody>
                                    <div
                                      className="border_transparent_up headingCard_up2 my-2"
                                      style={{
                                        cursor: "pointer",
                                        background: "#1a05ebc9",
                                      }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "senderIdRedirectToken",
                                          "0"
                                        );
                                        if (
                                          JSON.parse(
                                            localStorage.getItem("Sidebaritems")
                                          )?.name == "ROLE_SUPER_ADMIN"
                                        ) {
                                          document
                                            .getElementsByName(
                                              "sidebarLiConfiguration"
                                            )?.[0]
                                            ?.click();
                                          history?.push(
                                            "/dashboard/BlackOutTime"
                                          );
                                        } else {
                                        }
                                      }}
                                    >
                                      <th scope="row" className="d-flex gap-2">
                                        <Icon
                                          className="text-white"
                                          // class="d-block"
                                          component="i"
                                        >
                                          watch_later_icon
                                        </Icon>
                                        <span className="">Start Time</span>
                                      </th>
                                      <td>{data5?.startTime}</td>
                                    </div>

                                    <div
                                      className="border_transparent_up headingCard_up2 my-2"
                                      style={{
                                        cursor: "pointer",
                                        background: "#1a05ebc9",
                                      }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "templateRedirectToken",
                                          "0"
                                        );
                                        if (
                                          JSON.parse(
                                            localStorage.getItem("Sidebaritems")
                                          )?.name == "ROLE_SUPER_ADMIN"
                                        ) {
                                          document
                                            .getElementsByName(
                                              "sidebarLiConfiguration"
                                            )?.[0]
                                            ?.click();
                                          history?.push(
                                            "/dashboard/BlackOutTime"
                                          );
                                        } else {
                                        }
                                      }}
                                    >
                                      <th scope="row" className="d-flex gap-2">
                                        <Icon
                                          className="text-white"
                                          // class="d-block"
                                          component="i"
                                        >
                                          watch_later_icon
                                        </Icon>
                                        <span className="">End Time</span>
                                      </th>
                                      <td>{data5?.endTime}</td>
                                    </div>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        {data4?.tpsLimit && data4?.tpsLimit !== 0 ? (
                          <div class="col-xl-3 col-md-6 my-3">
                            <div
                              class="card card_1 card_border_radius "
                              style={{
                                height: "100%",
                                background:
                                  "linear-gradient(21deg, rgb(255 0 0) 0%, rgb(255 60 60 / 63%) 35%, rgb(255, 255, 255) 100%)",
                                cursor: "default",
                              }}
                            >
                              <div class="text-center d-flex justify-content-center ">
                                <div className="my-auto">
                                  <h1 className="fs-4 my-auto ">TPS</h1>
                                </div>
                                <div
                                  class="div_i8  ms-3"
                                  style={{
                                    backgroundColor: "rgb(255 0 0 / 25%)",
                                  }}
                                >
                                  <Icon
                                    sx={{
                                      color: "rgb(255 0 0 / 76%) !important",
                                    }}
                                    className="icon2_color_UP"
                                    // class="d-block"
                                    component="i"
                                  >
                                    schedule_send_icon
                                  </Icon>
                                </div>
                              </div>
                              <div className="mt-2">
                                <table class="table mb-0">
                                  <tbody>
                                    <div
                                      className="border_transparent_up headingCard_up2 my-2"
                                      style={{
                                        background: "#EB0505",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        localStorage.setItem(
                                          "senderIdRedirectToken",
                                          "0"
                                        );
                                        if (
                                          JSON.parse(
                                            localStorage.getItem("Sidebaritems")
                                          )?.name == "ROLE_SUPER_ADMIN"
                                        ) {
                                          document
                                            .getElementsByName(
                                              "sidebarLiTps Control"
                                            )?.[0]
                                            ?.click();
                                          history?.push("/dashboard/SystemTps");
                                        } else {
                                        }
                                      }}
                                    >
                                      <th scope="row" className="d-flex gap-2">
                                        <Icon
                                          className="text-white"
                                          // class="d-block"
                                          component="i"
                                        >
                                          data_thresholding_icon
                                        </Icon>
                                        <span className="">TPS Limit</span>
                                      </th>
                                      <td>{data4?.tpsLimit}</td>
                                    </div>

                                    {/* <div
                                  className="border_transparent_up headingCard_up2 my-2"
                                  style={{
                                    background: "#EB0505",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    localStorage.setItem(
                                      "templateRedirectToken",
                                      "0"
                                    );
                                    if (
                                      JSON.parse(
                                        localStorage.getItem("Sidebaritems")
                                      )?.name == "ROLE_SUPER_ADMIN"
                                    ) {
                                      document
                                        .getElementsByName(
                                          "sidebarLiApproval"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/Template");
                                    } else {
                                      document
                                        .getElementsByName(
                                          "sidebarLiTemplate Management"
                                        )?.[0]
                                        ?.click();
                                      history?.push("/dashboard/MyTemplate");
                                    }
                                  }}
                                >
                                  <th scope="row" className="d-flex gap-2">
                                    <Icon
                                      className="text-white"
                                      // class="d-block"
                                      component="i"
                                    >
                                      newspaper_icon
                                    </Icon>
                                    <span className="">Template</span>
                                  </th>
                                  <td>{data3?.pendingTemplate}</td>
                                </div> */}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                    {/* 
                  <div
                    class="col-xl-3 col-md-6 my-3 "
                    onClick={() => {
                      // if (dataTime.tabs == 0) {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Approved,template,${firstDay1},${lastDay1}`
                      //   );
                      // } else {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Approved,template,${firstDay},${lastDay}`
                      //   );
                      // }

                      localStorage?.setItem(
                        "dstQueCode1",
                        `Approved,template,${
                          dataTime.tabs == 0
                            ? firstDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : firstDay0
                        },${
                          dataTime.tabs == 0
                            ? lastDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : lastDay0
                        }`
                      );

                      history?.push("/dashboard/Dashboardreports");
                    }}
                  >
                    <div class="card card_1">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            newspaper_icon
                          </Icon>
                        </div>
                        <div>
                          <h3>
                            {data3?.templates?.toLocaleString("en-US")
                              ? data3?.templates?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                          <span>Approved Templates</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-md-6 my-3"
                    onClick={() => {
                      // if (dataTime.tabs == 0) {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Pending,template,${firstDay1},${lastDay1}`
                      //   );
                      // } else {
                      //   localStorage?.setItem(
                      //     "dstQueCode1",
                      //     `Pending,template,${firstDay},${lastDay}`
                      //   );
                      // }

                      localStorage?.setItem(
                        "dstQueCode1",
                        `Pending,template,${
                          dataTime.tabs == 0
                            ? firstDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : firstDay0
                        },${
                          dataTime.tabs == 0
                            ? lastDay11
                            : dataTime.tabs == 3
                            ? moment().format("YYYY-MM-DD")
                            : dataTime.tabs == 4
                            ? moment().add(-1, "day").format("YYYY-MM-DD")
                            : lastDay0
                        }`
                      );

                      history?.push("/dashboard/Dashboardreports");
                    }}
                  >
                    <div class="card card_3">
                      <div class="d-flex justify-content-between align-items-start">
                        <div class="div_i8">
                          <Icon
                            // class="d-block"
                            component="i"
                          >
                            newspaper_icon
                          </Icon>
                        </div>
                        <div>
                          <h3>
                            {data3?.pendingTemplate?.toLocaleString("en-US")
                              ? data3?.pendingTemplate?.toLocaleString("en-US")
                              : "0"}
                          </h3>
                          <span>Pending Templates</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  </div>
                </>
              )}
            </div>
          </div>
        ) : null}

        <div className="card mb-3">
          <div className="card-header pb-0 p-3 pt-2">
            <div className="d-flex justify-content-between px-2 mb-2">
              <div className="my-auto">
                <span
                  style={{ backgroundColor: "#3c8dbc", color: "white" }}
                  className="d-sm-inline ms_2 start_date_time_css"
                >
                  {moment(dataTime?.dateTabs0.startdateValue)?.format(
                    "DD-MMM-YYYY"
                  )}
                </span>
                <ForwardIcon />
                <span
                  style={{ backgroundColor: "#3c8dbc", color: "white" }}
                  className="d-sm-inline mx_2 start_date_time_css"
                >
                  {moment(dataTime?.dateTabs0.enddateValue)?.format(
                    "DD-MMM-YYYY"
                  )}
                </span>
              </div>
              {/* <div className="my-2 text-end">
              <span
                style={{ backgroundColor: "#3c8dbc", color: "white" }}
                className="d-sm-inline ms_2 start_date_time_css"
              >
                {selectedTime.start}
              </span>
              <ForwardIcon />
              <span
                style={{ backgroundColor: "#3c8dbc", color: "white" }}
                className="d-sm-inline mx_2 start_date_time_css"
              >
                {selectedTime.end}
              </span>

              <IconButton
                variant="text"
                size="small"
                sx={{
                  color: "rgba(0, 0, 0, 0.6)",
                }}
                // className="btn bg-gradient-primary "
                aria-describedby={
                  Boolean(anchorEll) ? "simple-popover" : undefined
                }
                onClick={(event) => {
                  setAnchorEll(event.currentTarget);
                }}
              >
                <CalendarMonthIcon />
              </IconButton>

              <Popover
                id={Boolean(anchorEll) ? "simple-popover" : undefined}
                open={Boolean(anchorEll)}
                anchorEl={anchorEll}
                onClose={() => {
                  setAnchorEll(null);
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <DateRangePickerr />
              </Popover>
            </div> */}

              <div className="my-auto">
                <div class="datePickerButtonsDashboard">
                  {[
                    {
                      name: "1D",
                      startdateValue: moment().format("YYYY-MM-DD"),
                      enddateValue: moment().format("YYYY-MM-DD"),
                      dateTypee: "Daily",
                      tooltipText: "1 Day",
                    },
                    // {
                    //   name: "Yesterday",
                    //   startdateValue: "",
                    //   enddateValue: "",
                    // },
                    {
                      name: "1W",
                      startdateValue: moment(addDays(new Date(), -7)).format(
                        "YYYY-MM-DD"
                      ),
                      enddateValue: moment().format("YYYY-MM-DD"),
                      dateTypee: "Daily",
                      tooltipText: "1 Week",
                    },
                    {
                      name: "1M",
                      enddateValue: moment().format("YYYY-MM-DD"),
                      startdateValue: moment(addDays(new Date(), -29)).format(
                        "YYYY-MM-DD"
                      ),
                      dateTypee: "Month",
                      startDateMonth: moment(
                        startOfMonth(addMonths(new Date(), -1))
                      ).format("YYYYMM"),
                      endDateMonth: moment().format("YYYYMM"),
                      tooltipText: "1 Month",
                    },
                    {
                      name: "3M",
                      startdateValue: moment(addMonths(new Date(), -3)).format(
                        "YYYY-MM-DD"
                      ),
                      enddateValue: moment().format("YYYY-MM-DD"),
                      dateTypee: "Monthly",
                      tooltipText: "3 Months",
                    },
                    {
                      name: "6M",
                      startdateValue: moment(addMonths(new Date(), -6)).format(
                        "YYYY-MM-DD"
                      ),
                      enddateValue: moment().format("YYYY-MM-DD"),
                      dateTypee: "Monthly",
                      tooltipText: "6 Months",
                    },
                  ].map((dataaa, index) => {
                    return (
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={dataaa.tooltipText}
                        onClick={() => {
                          seDataTime({
                            ...dataTime,
                            dateTabs0: dataaa,
                          });
                        }}
                        className={
                          dataTime.dateTabs0.name === dataaa.name
                            ? "active"
                            : ""
                        }
                      >
                        {" "}
                        {dataaa.name}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>

            <div class="row mb-4">
              {/* <DateRangePickerr /> */}
              <div class="col-md-6">
                <div class="card bar_card">
                  <div class="row mb-3">
                    <div class="col-md-9">
                      {/* <h6 class="user">User account vs spam manager</h6> */}
                      <h6 class="user">Number of Messages</h6>
                    </div>

                    <div class="col-md-3 ">
                      <FormControl fullWidth>
                        <InputLabel size="small" id="demo-simple-select-label">
                          Show by
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={dataTime.graph1}
                          label="Show by"
                          onChange={(e) => {
                            seDataTime({
                              ...dataTime,
                              graph1: e.target.value,
                            });
                          }}
                        >
                          <MenuItem value="Monthly">Month</MenuItem>
                          {/* <MenuItem value="Weeks">Week</MenuItem> */}
                          {/* {selectedTime?.dateType != "Monthly" && ( */}
                          <MenuItem value="Daily">Date</MenuItem>
                          {/* )} */}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <div class="border_btm"></div>
                  {/* <img class="img-fluid" src={g7} alt="" /> */}
                  <MultiGraph value={dataTime.graph1} />
                  {/* <MultiGraph /> */}
                </div>
              </div>

              <div class="col-md-6">
                <div class="card bar_card">
                  <div class="row mb-3">
                    <div class="col-md-9">
                      <h6 class="user">Campaigns</h6>
                    </div>

                    <div class="col-md-3">
                      <div className="w-100">
                        <FormControl fullWidth>
                          <InputLabel
                            size="small"
                            id="demo-simple-select-label"
                          >
                            Show by
                          </InputLabel>
                          <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={dataTime.line1}
                            label="Show by"
                            onChange={(e) => {
                              seDataTime({
                                ...dataTime,
                                line1: e.target.value,
                              });
                            }}
                          >
                            <MenuItem value="Monthly">Month</MenuItem>

                            <MenuItem value="Daily">Date</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>

                    {/* <div class="d-flex justify-content-between align-items-center mb-3">
                                  <>
                                    {" "}
                                    <IconButton
                                      aria-label="more"
                                      id="long-button"
                                      aria-controls={
                                        openmenue4 ? "long-menu" : undefined
                                      }
                                      aria-expanded={
                                        openmenue4 ? "true" : undefined
                                      }
                                      aria-haspopup="true"
                                      onClick={handleClickmenue4}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                  </>
                                <Menu
                                  id="long-menu"
                                  MenuListProps={{
                                    "aria-labelledby": "long-button",
                                  }}
                                  style={{ zIndex: "9999999999" }}
                                  anchorEl={anchorEl4}
                                  open={openmenue4}
                                  onClose={handleClosemenue4}
                                  PaperProps={{
                                    style: {
                                      width: "auto",
                                    },
                                  }}
                                  transformOrigin={{
                                    horizontal: "right",
                                    vertical: "top",
                                  }}
                                  anchorOrigin={{
                                    horizontal: "right",
                                    vertical: "bottom",
                                  }}
                                >
                                  <MenuItem
                                    onClick={handleClickExcel_revenucostDATA}
                                  >
                                    Save{" "}
                                    {ViewTableForm == true
                                      ? "Table"
                                      : "Graph  "}{" "}
                                    Data (Excel)
                                  </MenuItem>

                                  <MenuItem
                                    onClick={
                                  
                                        downloadChartAsPDF_revenucostDATA
                                    }
                                  >
                                    Save{" "}
                                    {ViewTableForm == true
                                      ? "Table"
                                      : "Graph Image "}{" "}
                                    (PDF)
                                  </MenuItem>

                                  <MenuItem onClick={enterFullScreen}>
                                    View Full{" "}
                                    {ViewTableForm == true
                                      ? "Table"
                                      : "Graph  "}
                                  </MenuItem>
                                </Menu>
                              </div> */}
                  </div>

                  <div class="border_btm"></div>
                  <MultiLineGraph value={dataTime.line1} />
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-3">
                <div class="card min_height">
                  <div class="row mt-2 mb-2">
                    <div class="col-md-12">
                      <h6 class="super">Templates</h6>
                    </div>
                  </div>

                  <div class="border_btm"></div>
                  <DoughnutGraph
                    value={dataTime.pie1}
                    api={"sms/dashboard/v1/get/template/pie-chart"}
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="card min_height">
                  <div class="row mt-2 mb-2">
                    <div class="col-md-12">
                      <h6 class="super">Sender Ids</h6>
                    </div>
                    {/* <div class="col-md-6 col_6">
                    <div>
                      <FormControl fullWidth>
                        <InputLabel size="small" id="demo-simple-select-label">
                          Show by
                        </InputLabel>
                        <Select
                          size="small"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={dataTime.pie1}
                          label="Show by"
                          onChange={(e) => {
                            seDataTime({
                              ...dataTime,
                              pie1: e.target.value,
                            });
                          }}
                        >
                          <MenuItem value="Month">Month</MenuItem>
                          <MenuItem value="Weeks">Weeks</MenuItem>
                          <MenuItem value="Days">Days</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div> */}
                  </div>

                  <div class="border_btm"></div>
                  <DoughnutGraph
                    value={dataTime.pie1}
                    api={"sms/dashboard/v1/get/sender-id/pie-chart"}
                  />
                </div>
              </div>

              {/* <div class="col-md-3">
                <div class="card min_height">
                  <div class="row mt-2  mb-3">
                    <div class="col-md-12">
                      <h6 class="super">SMS Push(Total : 6616)</h6>
                    </div>
                 
                  </div>

                  <div class="border_btm"></div>
                  <PieGraph value={dataTime.pie2} />
                </div>
              </div> */}

              {/* <div class="col-md-3">
                <div class="card min_height">
                  <div class="row mt-2  mb-2">
                    <div class="col-md-12">
                      <h6 class="super">Recharges</h6>
                    </div>
                  </div>

                  <div class="border_btm"></div>
                  <DoughnutGraph
                    value={dataTime.pie1}
                    api={"sms/dashboard/v1/get/recharge/pie-chart"}
                  />
                </div>
              </div> */}

              <div class="col-md-3">
                {/* <Link to={`/dashboard/CampaignsControl`}> */}
                <div class="card bar_card bar_card_8" id="bar_card">
                  <div class="row">
                    <div class="col-md-12 mb-2">
                      <h6 class="user p-0">Campaign</h6>
                    </div>
                    <div class="border_btm"></div>
                  </div>
                  <ProgressBar
                    value={dataTime.progress1}
                    lastDay={lastDay}
                    firstDay={firstDay}
                  />
                </div>
                {/* </Link> */}
              </div>

              {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
              "ROLE_SUPER_ADMIN" ? (
                <>
                  <div class="col-md-3">
                    <div
                      class="card bar_card bar_card_8 card_height_up"
                      id="bar_card1"
                    >
                      <div class="row">
                        <div class="col-md-12 mb-2">
                          <h6 class="user p-0">Top Sender Ids</h6>
                        </div>
                        <div class="border_btm"></div>
                      </div>

                      <UserProgressBar
                        type="senderId"
                        topSenderIdData={data6}
                        topSenderIdOpen={open6}
                      />
                    </div>

                    <div
                      class="card bar_card bar_card_8 card_height_up mb-0"
                      id="bar_card1"
                    >
                      <div class="row mt-2">
                        <div class="col-md-12 mb-2">
                          <h6 class="user p-0">Top Users</h6>
                        </div>
                        <div class="border_btm"></div>
                      </div>

                      <UserProgressBar
                        type="user"
                        topSenderIdData={data6}
                        topSenderIdOpen={open6}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div class="col-md-3">
                    <div class="card bar_card bar_card_8 " id="bar_card1">
                      <div class="row">
                        <div class="col-md-12 mb-2">
                          <h6 class="user p-0">Top Sender Ids</h6>
                        </div>
                        <div class="border_btm"></div>
                      </div>

                      <UserProgressBar
                        type="senderId"
                        topSenderIdData={data6}
                        topSenderIdOpen={open6}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="card mb-3">
          <div className="card-header p-3 py-4" id="stats">
            {/* <div class="container-fluid py-3"> */}

            <div className="d-flex justify-content-between px-2 mb-2">
              <div className="my-auto">
                <span
                  style={{ backgroundColor: "#3c8dbc", color: "white" }}
                  className="d-sm-inline ms_2 start_date_time_css"
                >
                  {moment(dataTime?.dateTabs1.startdateValue)?.format(
                    "DD-MMM-YYYY"
                  )}
                </span>
                <ForwardIcon />
                <span
                  style={{ backgroundColor: "#3c8dbc", color: "white" }}
                  className="d-sm-inline mx_2 start_date_time_css"
                >
                  {moment(dataTime?.dateTabs1.enddateValue)?.format(
                    "DD-MMM-YYYY"
                  )}
                </span>
              </div>

              <div className="my-auto">
                <div class="datePickerButtonsDashboard">
                  {[
                    {
                      name: "1D",
                      startdateValue: moment().format("YYYY-MM-DD"),
                      enddateValue: moment().format("YYYY-MM-DD"),
                      dateTypee: "Days",
                      tooltipText: "1 Day",
                    },
                    // {
                    //   name: "Yesterday",
                    //   startdateValue: "",
                    //   enddateValue: "",
                    // },
                    {
                      name: "1W",
                      startdateValue: moment(addDays(new Date(), -7)).format(
                        "YYYY-MM-DD"
                      ),
                      enddateValue: moment().format("YYYY-MM-DD"),
                      dateTypee: "Days",
                      tooltipText: "1 Week",
                    },
                    {
                      name: "1M",
                      enddateValue: moment().format("YYYY-MM-DD"),
                      startdateValue: moment(addDays(new Date(), -29)).format(
                        "YYYY-MM-DD"
                      ),
                      dateTypee: "Month",
                      startDateMonth: moment(
                        startOfMonth(addMonths(new Date(), -1))
                      ).format("YYYYMM"),
                      endDateMonth: moment().format("YYYYMM"),
                      tooltipText: "1 Month",
                    },
                    {
                      name: "3M",
                      startdateValue: moment(addMonths(new Date(), -3)).format(
                        "YYYY-MM-DD"
                      ),
                      enddateValue: moment().format("YYYY-MM-DD"),
                      dateTypee: "Month",
                      startDateMonth: moment(addMonths(new Date(), -3)).format(
                        "YYYYMM"
                      ),
                      endDateMonth: moment().format("YYYYMM"),
                      tooltipText: "3 Months",
                    },
                    {
                      name: "6M",
                      startdateValue: moment(addMonths(new Date(), -6)).format(
                        "YYYY-MM-DD"
                      ),
                      enddateValue: moment().format("YYYY-MM-DD"),
                      dateTypee: "Month",
                      startDateMonth: moment(addMonths(new Date(), -5)).format(
                        "YYYYMM"
                      ),
                      endDateMonth: moment().format("YYYYMM"),
                      tooltipText: "6 Months",
                    },
                  ].map((dataaa, index) => {
                    return (
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={dataaa.tooltipText}
                        onClick={() => {
                          seDataTime({
                            ...dataTime,
                            dateTabs1: dataaa,
                          });
                        }}
                        className={
                          dataTime.dateTabs1.name === dataaa.name
                            ? "active"
                            : ""
                        }
                      >
                        {" "}
                        {dataaa.name}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>

            <section
              class="card p-3"
              id="chnnel_8"
              ref={ref}
              // style={{
              //   display: isVisible ? "block" : "none",
              // }}
            >
              {isVisible ? (
                <div>
                  <h4 class="text-capitalize m-0">all channels performance</h4>
                  <div class="row mt-4">
                    {open1 ? (
                      <>
                        <div class="col-md-4">
                          <Skeleton variant="rectangular" height={218} />
                        </div>
                        <div class="col-md-4">
                          <Skeleton variant="rectangular" height={218} />
                        </div>
                        <div class="col-md-4">
                          <Skeleton variant="rectangular" height={218} />
                        </div>
                      </>
                    ) : (
                      <>
                        <div class="col-md-4">
                          <div class="d-flex align-items-center box">
                            <div class="w-100 text-center text-capitalize">
                              <Icon
                                style={{ fontSize: "36px", color: "green" }}
                                // class="d-block"
                                component="i"
                              >
                                mark_email_read_icon
                              </Icon>
                              <h1 class="m-0 my-1">
                                <Counter
                                  data={{
                                    id: "002",
                                    label: "Ice Cream Flavors",
                                    number:
                                      data1?.totalMessage !== null &&
                                      !isNaN(data1?.totalMessage)
                                        ? `${data1?.totalMessage?.toLocaleString(
                                            "en-US"
                                          )}`
                                        : "0",
                                    duration: "2",
                                  }}
                                />
                              </h1>
                              <p class="mt-">messages</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 my_4">
                          <div class="d-flex align-items-center box">
                            <div class="w-100 text-center text-capitalize">
                              <Icon
                                style={{ fontSize: "36px", color: "green" }}
                                // class="d-block"
                                component="i"
                              >
                                trending_up_icon
                              </Icon>
                              <h1 class="m-0 my-1">
                                <Counter
                                  data={{
                                    id: "002",
                                    label: "Ice Cream Flavors",
                                    number:
                                      data1?.percentage !== null &&
                                      !isNaN(data1?.percentage)
                                        ? `${`${data1?.percentage}`?.substring(
                                            0,
                                            `${data1?.percentage}`?.split(
                                              "."
                                            )?.[0]?.length
                                          )}`
                                        : "0",
                                    duration: "2",
                                  }}
                                />
                                {`${data1?.percentage}`
                                  ?.split(".")[1]
                                  ?.substring(0, 2) ? (
                                  <>
                                    .
                                    {`${data1?.percentage}`
                                      ?.split(".")[1]
                                      ?.substring(0, 2)}
                                  </>
                                ) : null}
                                %
                              </h1>
                              <p class="mt-">Delivery Rate</p>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="d-flex align-items-center box">
                            <div class="w-100 text-center text-capitalize">
                              <Icon
                                style={{ fontSize: "36px", color: "green" }}
                                // class="d-block"
                                component="i"
                              >
                                credit_score_icon
                              </Icon>
                              <h1 class="m-0 my-1">
                                {isNaN(data1?.totalCredit)
                                  ? Number("0")?.toLocaleString("en-US")
                                  : Number(data1?.totalCredit)?.toLocaleString(
                                      "en-US"
                                    )}
                              </h1>
                              <p class="mt-">Used Credit</p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : null}
            </section>

            <section class="card p-3 mt-4" id="status_8">
              <h4 class="text-capitalize m-0">Breakdown by Status</h4>
              <div class="row mt-3">
                {open2 ? (
                  <>
                    <div class="col-1 new_width">
                      <Skeleton variant="rectangular" height={200} />
                    </div>
                    <div class="col-1 new_width">
                      <Skeleton variant="rectangular" height={200} />
                    </div>
                    <div class="col-1 new_width">
                      <Skeleton variant="rectangular" height={200} />
                    </div>
                    <div class="col-1 new_width">
                      <Skeleton variant="rectangular" height={200} />
                    </div>
                    <div class="col-1 new_width">
                      <Skeleton variant="rectangular" height={200} />
                    </div>
                  </>
                ) : (
                  <>
                    <div class="col-1 new_width">
                      <div class="d-flex align-items-center box bg_1">
                        <div class="w-100 text-center text-capitalize">
                          <h1 class="m-0">
                            <CircularStatic
                              value={
                                data2?.delivered !== null
                                  ? data2?.delivered
                                  : 82
                              }
                              color={"white"}
                            />
                          </h1>
                          <p class="text-capitalize mt-1">delivered</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-1 new_width my_4">
                      <div class="d-flex align-items-center box bg_2">
                        <div class="w-100 text-center text-capitalize">
                          <h1 class="m-0">
                            {" "}
                            <CircularStatic
                              value={
                                data2?.rejected !== null ? data2?.rejected : 82
                              }
                              color={"white"}
                            />
                          </h1>
                          <p class="text-capitalize mt-1">failed</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-1 new_width">
                      <div class="d-flex align-items-center box bg_3">
                        <div class="w-100 text-center text-capitalize">
                          <h1 class="m-0">
                            {" "}
                            <CircularStatic
                              value={
                                data2?.pending !== null ? data2?.pending : 82
                              }
                              color={"white"}
                            />
                          </h1>
                          <p class="text-capitalize mt-1">pending</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-1 new_width my_4">
                      <div class="d-flex align-items-center box bg_4">
                        <div class="w-100 text-center text-capitalize">
                          <h1 class="m-0">
                            {" "}
                            <CircularStatic
                              value={
                                data2?.expired !== null ? data2?.expired : 82
                              }
                              color={"white"}
                            />
                          </h1>
                          <p class="text-capitalize mt-1">expired</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-1 new_width">
                      <div class="d-flex align-items-center box bg_5">
                        <div class="w-100 text-center text-capitalize">
                          <h1 class="m-0">
                            {" "}
                            <CircularStatic
                              value={
                                data2?.unDelivered !== null
                                  ? data2?.unDelivered
                                  : 82
                              }
                              color={"white"}
                            />
                          </h1>
                          <p class="text-capitalize mt-1">undelivered</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </section>
            {/* </div> */}
          </div>
        </div>
      </div>
    </main>
  );
}




// import React, { useState } from "react";
// import MenuGraph from "./MenuGraph";
// import DoughnutGraph from "./DoughnutGraph";
// import AreaGraph from "./AreaGraph";
// import PieGraph from "./PieGraph";
// import LineGraph from "./LineGraph";
// import ReactSpeedometer from "./Speedometer";
// import ReactSpeedometerss from "./Speedometer";
// import { MultiGraph } from "./MultiGraph";
// import { MultiLineGraph } from "./MulitLineGraph";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import CampaignIcon from "@mui/icons-material/Campaign";
// import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
// import MenuBookIcon from "@mui/icons-material/MenuBook";
// import { Link } from "react-router-dom";
// import DateRangePickerr from "./DateRangePicker";
// import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// import DataUsageIcon from "@mui/icons-material/DataUsage";
// import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
// import WalletIcon from "@mui/icons-material/Wallet";
// import FiberNewIcon from "@mui/icons-material/FiberNew";
// import Swal from "sweetalert2";
// import CancelIcon from "@mui/icons-material/Cancel";
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import ImageIcon from '@mui/icons-material/Image';
// import DescriptionIcon from '@mui/icons-material/Description';
// import {
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   Icon,
//   IconButton,
//   Popover,
//   Skeleton,
// } from "@mui/material";
// import DoughnutGraph1 from "./DoughnutGraph1";
// import PieGraph1 from "./PieGraph1";
// import { useDispatch, useSelector } from "react-redux";
// import ForwardIcon from "@mui/icons-material/Forward";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import { useEffect } from "react";
// import { toast } from "react-toastify";
// import { common_axios } from "../../../App";
// import ProgressBar from "./ProgressBar";
// import moment from "moment";
// import PieChartTest from "./PieChartTest";
// import UserProgressBar from "./UserProgressBar";
// import Counter from "./Counter";
// import CircularStatic from "./CircularStatic";
// import { useRef } from "react";
// import {
//   addDays,
//   endOfDay,
//   startOfDay,
//   startOfYear,
//   startOfMonth,
//   endOfMonth,
//   endOfYear,
//   addMonths,
//   subMonths,
//   addYears,
//   startOfWeek,
//   endOfWeek,
//   isSameDay,
//   differenceInCalendarDays,
// } from "date-fns";
// import {
//   setTimeSeries,
//   setTimeSeries1,
//   setTimeSeries2,
// } from "../../../redux/features/dashboardSlice";
// import html2canvas from "html2canvas";
// import { jsPDF } from "jspdf";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import Menu from "@mui/material/Menu";
// import * as XLSX from "xlsx";

// export default function Dashboard({ history }) {
//   const [anchorEll, setAnchorEll] = React.useState(null);

//   const selectedTime = useSelector(
//     (state) => state.dashboardReducer.timeSeries
//   );
//   const dispatch = useDispatch();
//   useEffect(() => {
//     if (selectedTime?.dateType == "Daily") {
//       seDataTime({
//         ...dataTime,
//         graph1: selectedTime?.dateType,
//         line1: selectedTime?.dateType,
//       });
//     }
//   }, [selectedTime?.buttonClicked]);

//   var date = new Date(),
//     y = date.getFullYear(),
//     m = date.getMonth();
//   var firstDay = new Date(y, m, 1);
//   var lastDay = new Date(y, m + 1, 0);

//   firstDay = moment(firstDay).format("YYYYMM");
//   lastDay = moment(lastDay).format("YYYYMM");
//   let firstDay0 = moment(new Date(y, m, 1)).format("YYYY-MM-DD");
//   let lastDay0 = moment(new Date(y, m + 1, 0)).format("YYYY-MM-DD");

//   var date1 = new Date(moment(new Date()).add(-1, "months")),
//     y1 = date1.getFullYear(),
//     m1 = date1.getMonth();
//   var firstDay1 = new Date(y1, m1, 1);
//   var lastDay1 = new Date(y1, m1 + 1, 0);

//   firstDay1 = moment(firstDay1).format("YYYYMM");
//   lastDay1 = moment(lastDay1).format("YYYYMM");
//   let firstDay11 = moment(new Date(y1, m1, 1)).format("YYYY-MM-DD");
//   let lastDay11 = moment(new Date(y1, m1 + 1, 0)).format("YYYY-MM-DD");

//   const currentMonth = moment().format("MM");
//   const currentYear = moment().format("YYYY");

//   const [data, setData] = useState(null);
//   const [data1, setData1] = useState(null);
//   const [data2, setData2] = useState(null);
//   const [data3, setData3] = useState(null);
//   const [data4, setData4] = useState(null);
//   const [data5, setData5] = useState(null);
//   const [open, setOpen] = useState(null);
//   const [open1, setOpen1] = useState(null);
//   const [open2, setOpen2] = useState(null);
//   const [open3, setOpen3] = useState(null);
//   const [open4, setOpen4] = useState(null);
//   const [open5, setOpen5] = useState(null);
//   const [data6, setData6] = useState(null);
//   const [open6, setOpen6] = useState(null);
//   const [globlecancel, setgloblecancel] = useState(false);
//   const [timeSeries2State, setTimeSeries2State] = useState(undefined);
//   const resd = useSelector((data) => data?.dashboardReducer);
//   var date = moment(new Date());
//   var now = moment(firstDay);
//   var duration = moment.duration(date.diff(now));
//   var noofDays = duration.asDays();
//   const [dataTime, seDataTime] = useState({
//     graph1: "Daily",
//     line1: "Daily",
//     pie1: null,
//     pie2: null,
//     pie3: null,
//     pie4: null,
//     tabs: localStorage.getItem("dashboardTopTabs")
//       ? localStorage.getItem("dashboardTopTabs")
//       : 3,
//     dateTabs0: {
//       name: "1M",
//       enddateValue: moment().format("YYYY-MM-DD"),
//       startdateValue: moment(addDays(new Date(), -29)).format("YYYY-MM-DD"),
//       dateTypee: "Month",
//       startDateMonth: moment(startOfMonth(addMonths(new Date(), -1))).format(
//         "YYYYMM"
//       ),
//       endDateMonth: moment().format("YYYYMM"),
//       tooltipText: "1 Month",
//     },
//     dateTabs1: {
//       name: "1M",
//       enddateValue: moment().format("YYYY-MM-DD"),
//       startdateValue: moment(addDays(new Date(), -29)).format("YYYY-MM-DD"),
//       dateTypee: "Month",
//       startDateMonth: moment(startOfMonth(addMonths(new Date(), -1))).format(
//         "YYYYMM"
//       ),
//       endDateMonth: moment().format("YYYYMM"),
//       tooltipText: "1 Month",
//     },
//   });
// //  console.log("kkoii", dataTime.tabs);
//   const fetchUserr = async () => {
//     try {
//       setOpen(true);

//       const res = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v2/get/All/Cards/data`,
//         {
//           dashBoardRequest: {
//             flag:
//               dataTime.tabs == 0
//                 ? "Previous Month"
//                 : dataTime.tabs == 3
//                 ? "Today"
//                 : dataTime.tabs == 4
//                 ? "Yesterday"
//                 : "Current Month",
//             monthCode:
//               dataTime.tabs == 0
//                 ? firstDay1
//                 : dataTime.tabs == 3
//                 ? null
//                 : dataTime.tabs == 4
//                 ? null
//                 : firstDay,
//             dailyCode:
//               dataTime.tabs == 0
//                 ? null
//                 : dataTime.tabs == 3
//                 ? moment().format("YYYY-MM-DD")
//                 : dataTime.tabs == 4
//                 ? moment().add(-1, "day").format("YYYY-MM-DD")
//                 : null,
//           },
//           role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//         }
//       );

//       if (res.data?.statusDescription?.statusCode == 200) {
//         if (res?.data?.cardResponse) setData(res.data?.cardResponse);
//         setOpen(false);
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };
//   const fetchPerformance = async () => {
//     try {
//       setOpen1(true);
//       localStorage.removeItem("counterViewed");
//       const res = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/All/performance`,
//         {
//           campaignRequest: {
//             startDateTime: dataTime?.dateTabs1?.startDateMonth
//               ? dataTime?.dateTabs1?.endDateMonth
//               : dataTime?.dateTabs1?.enddateValue,
//             endDateTime: dataTime?.dateTabs1?.startDateMonth
//               ? dataTime?.dateTabs1?.startDateMonth
//               : dataTime?.dateTabs1?.startdateValue,
//           },
//           flag: dataTime?.dateTabs1?.dateTypee,
//           role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//         }
//       );

//       if (res.data?.statusDescription?.statusCode == 200) {
//         if (res?.data?.performanceResponse)
//           setData1(res.data?.performanceResponse);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     } finally {
//       setOpen1(false);
//     }
//   };
//   const fetchPerformanceBreakdown = async () => {
//     try {
//       setOpen2(true);
//       localStorage.removeItem("counterViewed");
//       const res = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/All/break-down/performance`,
//         {
//           campaignRequest: {
//             startDateTime: dataTime?.dateTabs1?.startDateMonth
//               ? dataTime?.dateTabs1?.endDateMonth
//               : dataTime?.dateTabs1?.enddateValue,
//             endDateTime: dataTime?.dateTabs1?.startDateMonth
//               ? dataTime?.dateTabs1?.startDateMonth
//               : dataTime?.dateTabs1?.startdateValue,
//           },
//           flag: dataTime?.dateTabs1?.dateTypee,
//           role: JSON.parse(localStorage.getItem("Sidebaritems")).name,
//         }
//       );

//       if (res.data?.statusDescription?.statusCode == 200) {
//         if (res?.data?.performanceResponse)
//           setData2(res.data?.performanceResponse);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     } finally {
//       setOpen2(false);
//     }
//   };
//   const fetchSenderIdAndTemplate = async () => {
//     try {
//       setOpen3(true);
//       localStorage.removeItem("counterViewed");
//       const res = await common_axios(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/All/cards/approve-pending/senderId-template`
//       );

//       if (res.data?.statusDescription?.statusCode == 200) {
//         if (res?.data?.cardResponse) setData3(res.data?.cardResponse);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     } finally {
//       setOpen3(false);
//     }
//   };
//   const fetchBlackOutDetails = async () => {
//     try {
//       setOpen5(true);
//       localStorage.removeItem("counterViewed");
//       const res = await common_axios(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/black-out`
//       );

//       if (res.data?.statusDescription?.statusCode == 200) {
//         if (res?.data?.blackOutModel) setData5(res.data?.blackOutModel);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     } finally {
//       setOpen5(false);
//     }
//   };
//   const fetchSystemTps = async () => {
//     try {
//       setOpen4(true);
//       localStorage.removeItem("counterViewed");
//       const res = await common_axios(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/
// admin/v1/get/system-tps`
//       );

//       if (res.data?.statusDescription?.statusCode == 200) {
//         if (res?.data?.systemTpsModel) setData4(res.data?.systemTpsModel);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: res.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     } finally {
//       setOpen4(false);
//     }
//   };
//   const fetchMiddleCards = async () => {
//     try {
//       setOpen3(true);
//       localStorage.removeItem("counterViewed");
//       let res, res1, res2;

//       res1 = common_axios(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/All/cards/approve-pending/senderId-template`
//       );

//       if (
//         JSON.parse(localStorage.getItem("Sidebaritems"))?.name ===
//         "ROLE_SUPER_ADMIN"
//       ) {
//         res = common_axios(
//           `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/system-tps`
//         );

//         res2 = common_axios(
//           `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/black-out`
//         );
//       }

//       let arr =
//         JSON.parse(localStorage.getItem("Sidebaritems"))?.name ===
//         "ROLE_SUPER_ADMIN"
//           ? [res, res1, res2]
//           : [res1];
//       // console.log("kj",arr)
//       await Promise.allSettled(arr).then((result) => {
//         // console.log({ result });
//         if (
//           result?.[0]?.status === "fulfilled" &&
//           result?.[0]?.value?.data?.statusDescription?.statusCode === 200
//         ) {
//           if (result?.[0]?.value?.data?.systemTpsModel) {
//             setData4(result?.[0]?.value?.data?.systemTpsModel);
//           }
//         }
//         if (result.length == 1) {
//           if (
//             result?.[0]?.status === "fulfilled" &&
//             result?.[0]?.value?.data?.statusDescription?.statusCode === 200
//           ) {
//             if (result?.[0]?.value?.data?.cardResponse) {
//               setData3(result?.[0]?.value?.data?.cardResponse);
//             }
//           }
//         } else {
//           if (
//             result?.[1]?.status === "fulfilled" &&
//             result?.[1]?.value?.data?.statusDescription?.statusCode === 200
//           ) {
//             if (result?.[1]?.value?.data?.cardResponse) {
//               setData3(result?.[1]?.value?.data?.cardResponse);
//             }
//           }
//         }

//         if (
//           result?.[2]?.status === "fulfilled" &&
//           result?.[2]?.value?.data?.statusDescription?.statusCode === 200
//         ) {
//           if (result?.[2]?.value?.data?.blackOutModel) {
//             setData5(result?.[2]?.value?.data?.blackOutModel);
//           }
//         }
//       });
//     } catch (error) {
//       // console.log(error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     } finally {
//       setOpen3(false);
//     }
//   };

//   // const fetchTopSenderId = async () => {
//   //   try {
//   //     setOpen3(true);
//   //     localStorage.removeItem("counterViewed");
//   //     const res = await common_axios.post(
//   //       `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/top-5/senderId`,
//   //       {
//   //         campaignRequest: {
//   //           startDateTime: "2023-06-26",
//   //           endDateTime: "2023-06-01",
//   //         },
//   //       }
//   //     );

//   //     if (res.data?.statusDescription?.statusCode == 200) {
//   //       if (res?.data?.cardResponse) setData3(res.data?.cardResponse);
//   //     } else {
//   //       Swal.fire({
//   //         icon: "error",
//   //         title: "Oops...",
//   //         text: res.data.statusDescription.statusMessage,
//   //         // footer: '<a href="">Why do I have this issue?</a>'
//   //       });
//   //     }
//   //   } catch (error) {
//   //     // console.log(error);
//   //     Swal.fire({
//   //       icon: "error",
//   //       title: "Oops...",
//   //       text: "Something went wrong",
//   //       // footer: '<a href="">Why do I have this issue?</a>'
//   //     });
//   //   } finally {
//   //     setOpen3(false);
//   //   }
//   // };

//   // useEffect(() => {
//   //   fetchTopSenderId();
//   // }, [selectedTime?.start, selectedTime?.end]);

//   useEffect(() => {
//     fetchPerformance();
//     fetchPerformanceBreakdown();
//   }, [dataTime.dateTabs1]);

//   useEffect(() => {
//     setAnchorEll(null);
//   }, [selectedTime?.buttonClicked]);
//   useEffect(() => {
//     fetchUserr();
//   }, [dataTime?.tabs]);

//   const ref = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   const handleScroll = () => {
//     const rect = ref.current.getBoundingClientRect();
//     const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
//     setIsVisible(isVisible);
//   };

//   useEffect(() => {
//     // fetchSenderIdAndTemplate();
//     const options = {
//       passive: true,
//     };
//     fetchMiddleCards();
//     // if (
//     //   JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//     //   "ROLE_SUPER_ADMIN"
//     // ) {
//     //   fetchSystemTps();
//     //   fetchBlackOutDetails();
//     // }

//     window.addEventListener("scroll", handleScroll, options);

//     return () => {
//       window.removeEventListener("scroll", handleScroll, options);
//     };
//   }, []);

//   useEffect(() => {
//     dispatch(
//       setTimeSeries({
//         start: dataTime.dateTabs0.startdateValue,
//         end: dataTime.dateTabs0.enddateValue,
//         dateType: dataTime.dateTabs0?.dateTypee,
//         buttonClicked: false,
//       })
//     );
//   }, [dataTime.dateTabs0]);

//   async function topSenderData() {
//     // setTableLoader(true);
//     //
//     try {
//       setOpen6(true);
//       // setScheduleSkelton(true);
//       // sethideSkeleton(true)
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/top-5/senderId`,
//         {
//           campaignRequest: {
//             startDateTime: resd?.timeSeries?.end,
//             endDateTime: resd?.timeSeries?.start,
//           },
//         }
//       );
//       // console.log("------resultssss", result);
//       if (result.data.statusDescription.statusCode == 200) {
//         if (result?.data?.top5SenderIdAndUsers) {
//           result.data.top5SenderIdAndUsers[0].total =
//             result?.data?.top5SenderIdAndUsers?.reduce(
//               (partialSum, a) => {
//                 return partialSum + a.total_Sms_Count;
//               },

//               0
//             );

//           setData6(result?.data?.top5SenderIdAndUsers);
//         }
//       } else if (result.data.statusDescription.statusCode == 220) {
//         setData6([]);
//       } else {
//         // setScheduleSkelton(false);
//         // sethideSkeleton(false)
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusMessage,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       //   console.log(error);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     } finally {
//       setOpen6(false);
//     }
//     // console.log("response..", res);
//   }

//   useEffect(() => {
//     topSenderData();
//   }, [resd?.timeSeries?.end, resd?.timeSeries?.start]);

//   useEffect(() => {
//     localStorage.setItem("dashboardTopTabs", "3");
//   }, []);

//   useEffect(() => {
//     if (timeSeries2State != undefined) {
//       localStorage.setItem("TimeSeries2", JSON.stringify(timeSeries2State));
//     }
//   }, [timeSeries2State]);
//   // ..........................................................................................//
//   const [ViewTableForm, setViewTableForm] = React.useState(false);
//   const [anchorEl4, setAnchorEl4] = React.useState(null);
//   const openmenue4 = Boolean(anchorEl4);
//   const downloadRef_revenuecost = useRef(null);

//   const [isFullScreen, setFullScreen] = useState(false);



//   const downloadRef_revenuecost_child = useRef(null);
//   const [RevenueCostData, setRevenueCostData] = useState(null);
//   const handleClosemenue4 = () => {
//     setAnchorEl4(null);
//   };
//   const handleClickmenue4 = (event) => {
//     setAnchorEl4(event.currentTarget);
//   };


//   const enterFullScreen = () => {
//     handleClosemenue4();
//     // setgloblecancel(true)
//     setFullScreen(true)
//     const element = document.getElementById("revenucostgraphFull");
//     if (element) {
//       if (element.requestFullscreen) {
//         element
//           .requestFullscreen()
//           .then(() => setFullScreen(true))
//           .catch((error) => console.log("Error entering full-screen:", error));
//       } else if (element.webkitRequestFullscreen) {
//         // Safari
//         element
//           .webkitRequestFullscreen()
//           .then(() => setFullScreen(true))
//           .catch((error) => console.log("Error entering full-screen:", error));
//       } else if (element.msRequestFullscreen) {
//         // Internet Explorer
//         element
//           .msRequestFullscreen()
//           .then(() => setFullScreen(true))
//           .catch((error) => console.log("Error entering full-screen:", error));
//       } else {
//         setFullScreen(false);
//       }
//     }
//   };

//   const downloadChartAsPDF_revenucostDATA = async () => {
//     handleClosemenue4();
//     const element = downloadRef_revenuecost.current;
//     html2canvas(element, { scale: 2 }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");
//       const pdfWidth = 190;
//       const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
//       pdf.addImage(imgData, "PNG", 10, 10, pdfWidth, pdfHeight);

//       pdf.save("SuccessGraph.pdf");
//     });
//   };

//   const downloadChartAsPDF_revenucostDATA_forTable = async () => {
//     //  for img
//     setOpen(true);
//     handleClosemenue4();
//     const element = downloadRef_revenuecost_child.current;

//     html2canvas(element, { scale: 2 }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "pt", [320, 500]);
//       const pdfWidth = 300;
//       const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
//       if (pdf) {
//         setOpen(false);
//       }

//       pdf.addImage(imgData, "PNG", 20, 20, pdfWidth, pdfHeight);
//       pdf.save("Revenue & Cost.pdf");
//     });
//   };

//   const exitFullScreen = () => {
//     handleClosemenue4();
//     if (document.exitFullscreen) {
//       document
//         .exitFullscreen()
//         .then(() => setFullScreen(false))
//         .catch((error) => console.log("Error exiting full-screen:", error));
//     } else if (document.webkitExitFullscreen) {
//       // Safari
//       document
//         .webkitExitFullscreen()
//         .then(() => setFullScreen(false))
//         .catch((error) => console.log("Error exiting full-screen:", error));
//     } else if (document.msExitFullscreen) {
//       // Internet Explorer
//       document
//         .msExitFullscreen()
//         .then(() => setFullScreen(false))
//         .catch((error) => console.log("Error exiting full-screen:", error));
//     } else {
//       setFullScreen(false);
//     }
//   };

//   const handleClickExcel_revenucostDATA = () => {

//     handleClosemenue4();

//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.json_to_sheet([]);

 
//     const headers = ["Date", ...data.datasets.map((series) => series.label)];
//     XLSX.utils.sheet_add_json(worksheet, [headers], { skipHeader: true });


//     const rows = data.labels.map((xAxis, index) => {
//       const rowData = [
//         xAxis,
//         ...data.datasets.map((series) => series.data[index]),
//       ];
//       return rowData;
//     });
//     XLSX.utils.sheet_add_json(worksheet, rows, {
//       skipHeader: true,
//       origin: "A2",
//     });

//     XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

   

//     XLSX.writeFile(workbook, "FailedGraph.xlsx");
//   };


//   useEffect(() => {
//     window.addEventListener("resize", function () {
//       if (window.innerHeight >= window.screen.height - 20) {
//         console.log("The browser is in fullscreen mode");
      
//         if (globlecancel) {
//           setFullScreen(true);
//         }
//       } else {
//         console.log("The browser is NOT in fullscreen mode");
//         setFullScreen(false);
//         setgloblecancel(false);
//       }

//       // console.log('her')
//     });
//   }, []); 

//   return (
//     <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
//       <div className="home-section home_section p-4">
//         <div className="card mb-3">
//           <div className="card-header pb-0 p-3 pt-2">
//             <ul className="nav nav-tabs mt-2" id="myTab" role="tablist">
//               <li className="nav-item" role="presentation">
//                 <button
//                   className={
//                     dataTime.tabs == 3
//                       ? `nav-link ms-4  position-relative active`
//                       : `nav-link ms-4  position-relative `
//                   }
//                   id="SenderMasking-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#SenderMasking"
//                   type="button"
//                   role="tab"
//                   aria-controls="SenderMasking"
//                   aria-selected="false"
//                   onClick={() => {
//                     localStorage.setItem("dashboardTopTabs", 3);
//                     seDataTime({
//                       ...dataTime,
//                       tabs: 3,
//                     });
//                   }}
//                 >
//                   Today
//                 </button>
//               </li>

//               <li className="nav-item" role="presentation">
//                 <button
//                   className={
//                     dataTime.tabs == 4
//                       ? `nav-link ms-4  position-relative active`
//                       : `nav-link ms-4  position-relative `
//                   }
//                   id="SenderMasking-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#SenderMasking"
//                   type="button"
//                   role="tab"
//                   aria-controls="SenderMasking"
//                   aria-selected="false"
//                   onClick={() => {
//                     localStorage.setItem("dashboardTopTabs", 4);
//                     seDataTime({
//                       ...dataTime,
//                       tabs: 4,
//                     });
//                   }}
//                 >
//                   Yesterday
//                 </button>
//               </li>

//               <li className="nav-item" role="presentation">
//                 <button
//                   className={
//                     dataTime.tabs == 1
//                       ? `nav-link ms-4  position-relative active`
//                       : `nav-link ms-4  position-relative `
//                   }
//                   id="SenderMasking-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#SenderMasking"
//                   type="button"
//                   role="tab"
//                   aria-controls="SenderMasking"
//                   aria-selected="false"
//                   onClick={() => {
//                     localStorage.setItem("dashboardTopTabs", 1);
//                     seDataTime({
//                       ...dataTime,
//                       tabs: 1,
//                     });
//                   }}
//                 >
//                   Current Month
//                 </button>
//               </li>

//               <li className="nav-item" role="presentation">
//                 <button
//                   className={
//                     dataTime.tabs == 0
//                       ? `nav-link ms-4  position-relative active`
//                       : `nav-link ms-4  position-relative `
//                   }
//                   id="home-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#AccountDetails"
//                   type="button"
//                   role="tab"
//                   aria-controls="AccountDetails"
//                   aria-selected="true"
//                   onClick={() => {
//                     localStorage.setItem("dashboardTopTabs", 0);
//                     seDataTime({
//                       ...dataTime,
//                       tabs: 0,
//                     });
//                   }}
//                 >
//                   Previous Month
//                 </button>
//               </li>
//             </ul>
//           </div>

//           <div className="card-body">
//             {open ? (
//               <>
//                 <div className="row  my-2">
//                   <div className="col-md-3">
//                     <Skeleton
//                       variant="rectangular"
//                       width={"100%"}
//                       height={82}
//                     />
//                   </div>
//                   <div className="col-md-3">
//                     <Skeleton
//                       variant="rectangular"
//                       width={"100%"}
//                       height={82}
//                     />
//                   </div>
//                   <div className="col-md-3">
//                     <Skeleton
//                       variant="rectangular"
//                       width={"100%"}
//                       height={82}
//                     />
//                   </div>
//                   <div className="col-md-3">
//                     <Skeleton
//                       variant="rectangular"
//                       width={"100%"}
//                       height={82}
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-2 mt-4">
//                   <div className="col-md-3">
//                     <Skeleton
//                       variant="rectangular"
//                       width={"100%"}
//                       height={82}
//                     />
//                   </div>
//                   <div className="col-md-3">
//                     <Skeleton
//                       variant="rectangular"
//                       width={"100%"}
//                       height={82}
//                     />
//                   </div>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div class="row" id="card_8">
//                   <div
//                     class="col-xl-3 col-md-6 my-3"
//                     onClick={() => {
//                       // if (dataTime.tabs == 0) {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Approved,campaign,${firstDay11},${lastDay11}`
//                       //   );
//                       // } else {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Approved,campaign,${firstDay0},${lastDay0}`
//                       //   );
//                       // }

//                       localStorage?.setItem(
//                         "dstQueCode1",
//                         `Completed,campaign,${
//                           dataTime.tabs == 0
//                             ? firstDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : moment(
//                                 startOfMonth(addMonths(new Date(), -1))
//                               ).format("YYYY-MM-DD")
//                         },${
//                           dataTime.tabs == 0
//                             ? lastDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : moment().format("YYYY-MM-DD")
//                         }`
//                       );

//                       dispatch(
//                         setTimeSeries1({
//                           end:
//                             dataTime.tabs == 0
//                               ? lastDay11
//                               : dataTime.tabs == 3
//                               ? moment().format("YYYY-MM-DD")
//                               : dataTime.tabs == 4
//                               ? moment().add(-1, "day").format("YYYY-MM-DD")
//                               : moment().add(-2, "days").format("YYYY-MM-DD"),
//                           start:
//                             dataTime.tabs == 0
//                               ? firstDay11
//                               : dataTime.tabs == 3
//                               ? moment().format("YYYY-MM-DD")
//                               : dataTime.tabs == 4
//                               ? moment().add(-1, "day").format("YYYY-MM-DD")
//                               : moment(startOfMonth(new Date())).format(
//                                   "YYYY-MM-DD"
//                                 ),
//                           dateType: "Daily",
//                           approveType: "Completed",
//                         })
//                       );
//                       document
//                         .getElementsByName("sidebarLiReports")?.[0]
//                         ?.click();

//                       // history?.push("/dashboard/TransactionalReport");
//                       if (dataTime?.tabs == 3 || dataTime?.tabs == 4) {
//                         history?.push("/dashboard/48HourReport");
//                       } else {
//                         history?.push("/dashboard/TransactionalReport");
//                       }
//                     }}
//                   >
//                     <div class="card card_1">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             check_circle_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3>
//                             {data?.totalCampaign?.toLocaleString("en-US")
//                               ? data?.totalCampaign?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
//                           <span>Completed Campaigns</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     class="col-xl-3 col-md-6 my-3"
//                     onClick={() => {
//                       localStorage?.setItem(
//                         "dstQueCode1",
//                         `Stopped,campaign,${
//                           dataTime.tabs == 0
//                             ? firstDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : moment(
//                                 startOfMonth(addMonths(new Date(), -1))
//                               ).format("YYYY-MM-DD")
//                         },${
//                           dataTime.tabs == 0
//                             ? lastDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : moment().format("YYYY-MM-DD")
//                         }`
//                       );

//                       dispatch(
//                         setTimeSeries1({
//                           end:
//                             dataTime.tabs == 0
//                               ? lastDay11
//                               : dataTime.tabs == 3
//                               ? moment().format("YYYY-MM-DD")
//                               : dataTime.tabs == 4
//                               ? moment().add(-1, "day").format("YYYY-MM-DD")
//                               : moment().add(-2, "days").format("YYYY-MM-DD"),
//                           start:
//                             dataTime.tabs == 0
//                               ? firstDay11
//                               : dataTime.tabs == 3
//                               ? moment().format("YYYY-MM-DD")
//                               : dataTime.tabs == 4
//                               ? moment().add(-1, "day").format("YYYY-MM-DD")
//                               : moment(startOfMonth(new Date())).format(
//                                   "YYYY-MM-DD"
//                                 ),
//                           dateType: "Daily",
//                           approveType: "Failed",
//                         })
//                       );
//                       document
//                         .getElementsByName("sidebarLiReports")?.[0]
//                         ?.click();
//                       // history?.push("/dashboard/TransactionalReport");
//                       if (dataTime?.tabs == 3 || dataTime?.tabs == 4) {
//                         history?.push("/dashboard/48HourReport");
//                       } else {
//                         history?.push("/dashboard/TransactionalReport");
//                       }
//                     }}
//                   >
//                     <div class="card card_2">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon component="i">cancel_schedule_send_icon</Icon>
//                         </div>
//                         <div>
//                           <h3>
//                             {data?.failedCampaign?.toLocaleString("en-US")
//                               ? data?.failedCampaign?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
//                           <span>Failed Campaigns</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     class="col-xl-3 col-md-6 my-3"
//                     onClick={async () => {
//                       // if (dataTime.tabs == 0) {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Approved,successM,${firstDay1},${lastDay1}`
//                       //   );
//                       // } else {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Approved,successM,${firstDay},${lastDay}`
//                       //   );
//                       // }

//                       localStorage?.setItem(
//                         "dstQueCode1",
//                         `Approved,successM,${
//                           dataTime.tabs == 0
//                             ? firstDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : firstDay0
//                         },${
//                           dataTime.tabs == 0
//                             ? lastDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : lastDay0
//                         }`
//                       );

//                       // history?.push("/dashboard/DashboardReportss");

//                       // if(dataTime?.tabs==3 || dataTime?.tabs==4){
//                       //   history?.push("/dashboard/DashboardReportss");
//                       // }else{
//                       //   history?.push("/dashboard/SuccessGraph");
//                       // }
//                       if (dataTime.tabs == 3) {
//                         await setTimeSeries2State({
//                           end: moment(new Date()).format("YYYY-MM-DD"),
//                           // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                           start: moment(new Date()).format("YYYY-MM-DD"),
//                           dateType: "Month",
//                           buttonClicked: false,
//                           approveType: "Completed",
//                         });
//                         dispatch(
//                           setTimeSeries2({
//                             end: moment(new Date()).format("YYYY-MM-DD"),
//                             // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                             start: moment(new Date()).format("YYYY-MM-DD"),
//                             dateType: "Month",
//                             buttonClicked: false,
//                             approveType: "Completed",
//                             // start: "",
//                             // end: "",
//                           })
//                         );
//                       } else if (dataTime.tabs == 4) {
//                         await setTimeSeries2State({
//                           end: moment(new Date())
//                             .subtract("days", 1)
//                             .format("YYYY-MM-DD"),
//                           // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                           start: moment(new Date())
//                             .subtract("days", 1)
//                             .format("YYYY-MM-DD"),
//                           dateType: "Month",
//                           buttonClicked: false,
//                           approveType: "Completed",
//                         });
//                         dispatch(
//                           setTimeSeries2({
//                             end: moment(new Date())
//                               .subtract("days", 1)
//                               .format("YYYY-MM-DD"),
//                             // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                             start: moment(new Date())
//                               .subtract("days", 1)
//                               .format("YYYY-MM-DD"),
//                             dateType: "Month",
//                             buttonClicked: false,
//                             approveType: "Completed",
//                             // start: "",
//                             // end: "",
//                           })
//                         );
//                       } else if (dataTime.tabs == 1) {
//                         await setTimeSeries2State({
//                           end: moment(new Date()).format("YYYY-MM-DD"),

//                           start: `${currentYear}-${currentMonth}-01`,
//                           dateType: "Month",
//                           buttonClicked: false,
//                           approveType: "Completed",
//                         });
//                         dispatch(
//                           setTimeSeries2({
//                             end: moment(new Date()).format("YYYY-MM-DD"),

//                             start: `${currentYear}-${currentMonth}-01`,
//                             dateType: "Month",
//                             buttonClicked: false,
//                             approveType: "Completed",
//                           })
//                         );
//                       } else if (dataTime.tabs == 0) {
//                         await setTimeSeries2State({
//                           end: moment(new Date())
//                             .subtract("days", 1)
//                             .format("YYYY-MM-DD"),
//                           // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                           start: moment(new Date())
//                             .subtract("days", 1)
//                             .format("YYYY-MM-DD"),
//                           dateType: "Month",
//                           buttonClicked: false,
//                           approveType: "Completed",
//                         });
//                         dispatch(
//                           setTimeSeries2({
//                             // end: moment(new Date())
//                             //   .subtract("days", 1)
//                             //   .format("YYYY-MM-DD"),


// end:moment().endOf('month').subtract("months",1).format("YYYY-MM-DD") ,

//                             // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),


// start: `${moment(new Date()).subtract("months",1).format("YYYY-MM")}-01`,

//                             // start: moment(new Date())
//                             //   .subtract("days", 1)
//                             //   .format("YYYY-MM-DD"),
//                             dateType: "Month",
//                             buttonClicked: false,
//                             approveType: "Completed",
//                             // start: "",
//                             // end: "",
//                           })
//                         );
//                       }
//                       history?.push("/dashboard/SuccessGraph");
//                     }}
//                   >
//                     <div class="card card_1">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             mark_email_read_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3>
//                             {data?.totalSuccessMessage?.toLocaleString("en-US")
//                               ? data?.totalSuccessMessage?.toLocaleString(
//                                   "en-US"
//                                 )
//                               : "0"}
//                           </h3>
//                           <span>Success Messages</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     class="col-xl-3 col-md-6 my-3"
//                     onClick={async () => {
//                       // if (dataTime.tabs == 0) {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Approved,failedM,${firstDay1},${lastDay1}`
//                       //   );
//                       // } else {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Approved,failedM,${firstDay},${lastDay}`
//                       //   );
//                       // }

//                       localStorage?.setItem(
//                         "dstQueCode1",
//                         `Approved,failedM,${
//                           dataTime.tabs == 0
//                             ? firstDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : firstDay0
//                         },${
//                           dataTime.tabs == 0
//                             ? lastDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : lastDay0
//                         }`
//                       );
                     


//                         if (dataTime.tabs == 3) {
//                         await setTimeSeries2State({
//                           end: moment(new Date()).format("YYYY-MM-DD"),
//                           // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                           start: moment(new Date()).format("YYYY-MM-DD"),
//                           dateType: "Month",
//                           buttonClicked: false,
//                           approveType: "Completed",
//                         });                                  
//                         dispatch(
//                           setTimeSeries2({
//                             end: moment(new Date()).format("YYYY-MM-DD"),
//                             // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                             start: moment(new Date()).format("YYYY-MM-DD"),
//                             dateType: "Month",
//                             buttonClicked: false,
//                             approveType: "Completed",
//                             // start: "",
//                             // end: "",
//                           })
//                         );
//                       } else if (dataTime.tabs == 4) {
//                         await setTimeSeries2State({
//                           end: moment(new Date())
//                             .subtract("days", 1)
//                             .format("YYYY-MM-DD"),
//                           // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                           start: moment(new Date())
//                             .subtract("days", 1)
//                             .format("YYYY-MM-DD"),
//                           dateType: "Month",
//                           buttonClicked: false,
//                           approveType: "Completed",
//                         });
//                         dispatch(
//                           setTimeSeries2({
//                             end: moment(new Date())
//                               .subtract("days", 1)
//                               .format("YYYY-MM-DD"),
//                             // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                             start: moment(new Date())
//                               .subtract("days", 1)
//                               .format("YYYY-MM-DD"),
//                             dateType: "Month",
//                             buttonClicked: false,
//                             approveType: "Completed",
//                             // start: "",
//                             // end: "",
//                           })
//                         );
//                       } else if (dataTime.tabs == 1) {
//                         await setTimeSeries2State({
//                           end: moment(new Date()).format("YYYY-MM-DD"),

//                           start: `${currentYear}-${currentMonth}-01`,
//                           dateType: "Month",
//                           buttonClicked: false,
//                           approveType: "Completed",
//                         });
//                         dispatch(
//                           setTimeSeries2({
//                             end: moment(new Date()).format("YYYY-MM-DD"),

//                             start: `${currentYear}-${currentMonth}-01`,
//                             dateType: "Month",
//                             buttonClicked: false,
//                             approveType: "Completed",
//                           })
//                         );
//                       } else if (dataTime.tabs == 0) {
//                         await setTimeSeries2State({
//                           end: moment(new Date())
//                             .subtract("days", 1)
//                             .format("YYYY-MM-DD"),
//                           // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                           start: moment(new Date())
//                             .subtract("days", 1)
//                             .format("YYYY-MM-DD"),
//                           dateType: "Month",
//                           buttonClicked: false,
//                           approveType: "Completed",
//                         });
//                         dispatch(
//                           setTimeSeries2({
//                             // end: moment(new Date())
//                             //   .subtract("days", 1)
//                             //   .format("YYYY-MM-DD"),


// end:moment().endOf('month').subtract("months",1).format("YYYY-MM-DD") ,

//                             // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),


// start: `${moment(new Date()).subtract("months",1).format("YYYY-MM")}-01`,

//                             // start: moment(new Date())
//                             //   .subtract("days", 1)
//                             //   .format("YYYY-MM-DD"),
//                             dateType: "Month",
//                             buttonClicked: false,
//                             approveType: "Completed",
//                             // start: "",
//                             // end: "",
//                           })
//                         );
//                       }
//                         // dispatch(
//                         //   setTimeSeries2({
//                         //     end: moment(new Date()).format("YYYY-MM-DD"),
//                         //     // start: moment(addDays(new Date(), -30)).format("YYYY-MM-DD"),

//                         //     start: moment(new Date()).format("YYYY-MM-DD"),
//                         //     dateType: "Month",
//                         //     buttonClicked: false,
//                         //     approveType: "Completed",
//                         //     // start: "",
//                         //     // end: "",
//                         //   })
//                         // );
                      
//                       // history?.push("/dashboard/DashboardReportss");
//                       // history?.push("/dashboard/FailedGraph");

//                       // if(dataTime?.tabs==3 || dataTime?.tabs==4){
//                       //   history?.push("/dashboard/DashboardReportss");
//                       // }else{
//                       //   history?.push("/dashboard/FailedGraph");
//                       // }

//                       history?.push("/dashboard/FailedGraph");
//                     }}
//                   >
//                     <div class="card card_2">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             sms_failed_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3>
//                             {data?.totalFailMessage?.toLocaleString("en-US")
//                               ? data?.totalFailMessage?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
//                           <span>Failed Messages</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* <div
//                     class="col-xl-3 col-md-6 my-3"
//                     onClick={() => {
//                       if (dataTime.tabs == 0) {
//                         localStorage?.setItem(
//                           "dstQueCode1",
//                           `Success,recharge,${firstDay1},${lastDay1}`
//                         );
//                       } else {
//                         localStorage?.setItem(
//                           "dstQueCode1",
//                           `Success,recharge,${firstDay},${lastDay}`
//                         );
//                       }

//                       history?.push("/dashboard/Dashboardreports");
//                     }}
//                   >
//                     <div class="card card_1">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             account_balance_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3> {data?.recharges ? data?.recharges : "0"}</h3>
//                           <span>Success Recharges</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div> */}
//                 </div>
//                 <div class="row" id="card_8">
//                   <div class="col-xl-3 col-md-6 my-3">
//                     <div class="card card_1">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             check_circle_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3>
//                             {data?.totalCreditUtilization?.toLocaleString(
//                               "en-US"
//                             )
//                               ? data?.totalCreditUtilization?.toLocaleString(
//                                   "en-US"
//                                 )
//                               : "0"}
//                           </h3>
//                           <span>Credit Utilized</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     class="col-xl-3 col-md-6 my-3"
//                     onClick={() => {
//                       document
//                         .getElementsByName("sidebarLiReports")?.[0]
//                         ?.click();
//                       history?.push("/dashboard/RechargeReport");
//                     }}
//                   >
//                     <div class="card card_2">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             cancel_schedule_send_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3>
//                             {data?.totalRecharges?.toLocaleString("en-US")
//                               ? data?.totalRecharges?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
//                           <span>Recharge Amount</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* <div
//                     class="col-xl-3 col-md-6 my-3"
//                     onClick={() => {
//                       if (dataTime.tabs == 0) {
//                         localStorage?.setItem(
//                           "dstQueCode1",
//                           `Success,recharge,${firstDay1},${lastDay1}`
//                         );
//                       } else {
//                         localStorage?.setItem(
//                           "dstQueCode1",
//                           `Success,recharge,${firstDay},${lastDay}`
//                         );
//                       }

//                       history?.push("/dashboard/Dashboardreports");
//                     }}
//                   >
//                     <div class="card card_1">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             account_balance_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3> {data?.recharges ? data?.recharges : "0"}</h3>
//                           <span>Success Recharges</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div> */}
//                 </div>
//               </>
//             )}
//           </div>
//         </div>

//         {open3 ||
//         (data3?.pendingSenderId && data3?.pendingSenderId !== 0) ||
//         (data3?.pendingTemplate && data3?.pendingTemplate !== 0) ||
//         (data3?.senderIds && data3?.senderIds !== 0) ||
//         (data3?.templates && data3?.templates !== 0) ? (
//           <div className="card mb-3">
//             <div className="card-body">
//               {open3 ? (
//                 <>
//                   <div className="row my-2">
//                     <div className="col-xl-3 col-md-6">
//                       <Skeleton
//                         variant="rectangular"
//                         sx={{
//                           borderRadius: "0px 30px 0px 30px !important",
//                         }}
//                         width={"100%"}
//                         height={182}
//                       />
//                     </div>
//                     <div className="col-xl-3 col-md-6">
//                       <Skeleton
//                         variant="rectangular"
//                         sx={{
//                           borderRadius: "0px 30px 0px 30px !important",
//                         }}
//                         width={"100%"}
//                         height={182}
//                       />
//                     </div>
//                     {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//                     "ROLE_SUPER_ADMIN" ? (
//                       <>
//                         <div className="col-xl-3 col-md-6">
//                           <Skeleton
//                             variant="rectangular"
//                             sx={{
//                               borderRadius: "0px 30px 0px 30px !important",
//                             }}
//                             width={"100%"}
//                             height={182}
//                           />
//                         </div>
//                         <div className="col-xl-3 col-md-6">
//                           <Skeleton
//                             variant="rectangular"
//                             sx={{
//                               borderRadius: "0px 30px 0px 30px !important",
//                             }}
//                             width={"100%"}
//                             height={182}
//                           />
//                         </div>
//                       </>
//                     ) : null}
//                     {/* <div className="col-md-3">
//                     <Skeleton
//                       variant="rectangular"
//                       width={"100%"}
//                       height={82}
//                     />
//                   </div>
//                   <div className="col-md-3">
//                     <Skeleton
//                       variant="rectangular"
//                       width={"100%"}
//                       height={82}
//                     />
//                   </div> */}
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div class="row justify-content-start" id="card_8">
//                     {(data3?.pendingSenderId && data3?.pendingSenderId !== 0) ||
//                     (data3?.pendingTemplate && data3?.pendingTemplate !== 0) ? (
//                       <div
//                         class="col-xl-3 col-md-6 my-3"
//                         // onClick={() => {
//                         //   // if (dataTime.tabs == 0) {
//                         //   //   localStorage?.setItem(
//                         //   //     "dstQueCode1",
//                         //   //     `Approved,sender-id,${firstDay1},${lastDay1}`
//                         //   //   );
//                         //   // } else {
//                         //   //   localStorage?.setItem(
//                         //   //     "dstQueCode1",
//                         //   //     `Approved,sender-id,${firstDay},${lastDay}`
//                         //   //   );
//                         //   // }

//                         //   localStorage?.setItem(
//                         //     "dstQueCode1",
//                         //     `Approved,sender-id,${
//                         //       dataTime.tabs == 0
//                         //         ? firstDay11
//                         //         : dataTime.tabs == 3
//                         //         ? moment().format("YYYY-MM-DD")
//                         //         : dataTime.tabs == 4
//                         //         ? moment().add(-1, "day").format("YYYY-MM-DD")
//                         //         : firstDay0
//                         //     },${
//                         //       dataTime.tabs == 0
//                         //         ? lastDay11
//                         //         : dataTime.tabs == 3
//                         //         ? moment().format("YYYY-MM-DD")
//                         //         : dataTime.tabs == 4
//                         //         ? moment().add(-1, "day").format("YYYY-MM-DD")
//                         //         : lastDay0
//                         //     }`
//                         //   );

//                         //   history?.push("/dashboard/Dashboardreports");
//                         // }}
//                       >
//                         <div
//                           class="card card_1 card_border_radius "
//                           style={{
//                             background:
//                               "linear-gradient(21deg, rgba(255,139,0,1) 0%, rgba(255,166,60,1) 35%, rgba(255,255,255,1) 100%)",
//                             cursor: "default",
//                           }}
//                         >
//                           <div class="text-center d-flex justify-content-center ">
//                             <div className="my-auto">
//                               <h1 className="fs-4 my-auto ">Pending</h1>
//                               {JSON.parse(localStorage.getItem("Sidebaritems"))
//                                 ?.name == "ROLE_SUPER_ADMIN" ? (
//                                 <span
//                                   classname="mt-1 text-black"
//                                   id="blinkSpan"
//                                 >
//                                   (Action Required)
//                                 </span>
//                               ) : null}
//                             </div>
//                             <div
//                               class="div_i8  ms-3"
//                               style={{
//                                 backgroundColor: "rgb(255 120 0 / 25%)",
//                               }}
//                             >
//                               <Icon
//                                 className="icon2_color_UP"
//                                 // class="d-block"
//                                 component="i"
//                               >
//                                 watch_later_icon
//                               </Icon>
//                             </div>

//                             {/* <div>
//                           <h3>
//                             {data3?.senderIds?.toLocaleString("en-US")
//                               ? data3?.senderIds?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
                         
//                         </div> */}
//                           </div>
//                           <div className="mt-2">
//                             <table class="table mb-0">
//                               <tbody>
//                                 <div
//                                   className="border_transparent_up headingCard_up2 my-2"
//                                   style={{
//                                     cursor: "pointer",
//                                   }}
//                                   onClick={() => {
//                                     localStorage.setItem(
//                                       "senderIdRedirectToken",
//                                       "0"
//                                     );
//                                     if (
//                                       JSON.parse(
//                                         localStorage.getItem("Sidebaritems")
//                                       )?.name == "ROLE_SUPER_ADMIN"
//                                     ) {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiApproval"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/SenderId");
//                                     } else {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiSenderId Management"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/MySenderId");
//                                     }
//                                   }}
//                                 >
//                                   <th scope="row" className="d-flex gap-2">
//                                     <Icon className="text-white" component="i">
//                                       contact_phone_icon
//                                     </Icon>
//                                     <span className="">Sender Id</span>
//                                   </th>
//                                   <td>{data3?.pendingSenderId}</td>
//                                 </div>

//                                 <div
//                                   className="border_transparent_up headingCard_up2 my-2"
//                                   style={{
//                                     cursor: "pointer",
//                                   }}
//                                   onClick={() => {
//                                     localStorage.setItem(
//                                       "templateRedirectToken",
//                                       "0"
//                                     );
//                                     if (
//                                       JSON.parse(
//                                         localStorage.getItem("Sidebaritems")
//                                       )?.name == "ROLE_SUPER_ADMIN"
//                                     ) {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiApproval"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/Template");
//                                     } else {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiTemplate Management"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/MyTemplate");
//                                     }
//                                   }}
//                                 >
//                                   <th scope="row" className="d-flex gap-2">
//                                     <Icon
//                                       className="text-white"
//                                       // class="d-block"
//                                       component="i"
//                                     >
//                                       newspaper_icon
//                                     </Icon>
//                                     <span className="">Template</span>
//                                   </th>
//                                   <td>{data3?.pendingTemplate}</td>
//                                 </div>
//                               </tbody>
//                             </table>
//                           </div>
//                         </div>
//                       </div>
//                     ) : null}

//                     {(data3?.senderIds && data3?.senderIds !== 0) ||
//                     (data3?.templates && data3?.templates !== 0) ? (
//                       <div
//                         class="col-xl-3 col-md-6 my-3"
//                         // onClick={() => {
//                         //   // if (dataTime.tabs == 0) {
//                         //   //   localStorage?.setItem(
//                         //   //     "dstQueCode1",
//                         //   //     `Approved,sender-id,${firstDay1},${lastDay1}`
//                         //   //   );
//                         //   // } else {
//                         //   //   localStorage?.setItem(
//                         //   //     "dstQueCode1",
//                         //   //     `Approved,sender-id,${firstDay},${lastDay}`
//                         //   //   );
//                         //   // }

//                         //   localStorage?.setItem(
//                         //     "dstQueCode1",
//                         //     `Approved,sender-id,${
//                         //       dataTime.tabs == 0
//                         //         ? firstDay11
//                         //         : dataTime.tabs == 3
//                         //         ? moment().format("YYYY-MM-DD")
//                         //         : dataTime.tabs == 4
//                         //         ? moment().add(-1, "day").format("YYYY-MM-DD")
//                         //         : firstDay0
//                         //     },${
//                         //       dataTime.tabs == 0
//                         //         ? lastDay11
//                         //         : dataTime.tabs == 3
//                         //         ? moment().format("YYYY-MM-DD")
//                         //         : dataTime.tabs == 4
//                         //         ? moment().add(-1, "day").format("YYYY-MM-DD")
//                         //         : lastDay0
//                         //     }`
//                         //   );

//                         //   history?.push("/dashboard/Dashboardreports");
//                         // }}
//                       >
//                         <div
//                           class="card bg_bg_card card_border_radius"
//                           style={{
//                             cursor: "default",
//                           }}
//                         >
//                           <div class="text-center d-flex justify-content-center ">
//                             <div className="my-auto">
//                               <h1 className="fs-4 my-auto"> All Approved</h1>
//                             </div>
//                             <div class="div_i8 ms-3 card_icon_UP">
//                               <Icon
//                                 // class="d-block"
//                                 component="i"
//                               >
//                                 check_circle_icon
//                               </Icon>
//                             </div>

//                             {/* <div>
//                           <h3>
//                             {data3?.senderIds?.toLocaleString("en-US")
//                               ? data3?.senderIds?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
                         
//                         </div> */}
//                           </div>
//                           <div className="mt-2">
//                             <table class="table mb-0">
//                               <tbody>
//                                 <div
//                                   className="border_transparent_up headingCard_up my-2"
//                                   onClick={() => {
//                                     if (
//                                       JSON.parse(
//                                         localStorage.getItem("Sidebaritems")
//                                       )?.name == "ROLE_SUPER_ADMIN"
//                                     ) {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiApproval"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/SenderId");
//                                     } else {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiSenderId Management"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/MySenderId");
//                                     }
//                                   }}
//                                   style={{
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   <th scope="row" className="d-flex gap-2">
//                                     <Icon
//                                       className="text-white"
//                                       // class="d-block"
//                                       component="i"
//                                     >
//                                       contact_phone_icon
//                                     </Icon>

//                                     <span className="">Sender Id</span>
//                                   </th>
//                                   <td>{data3?.senderIds}</td>
//                                 </div>

//                                 <div
//                                   className="border_transparent_up headingCard_up my-2"
//                                   onClick={() => {
//                                     if (
//                                       JSON.parse(
//                                         localStorage.getItem("Sidebaritems")
//                                       )?.name == "ROLE_SUPER_ADMIN"
//                                     ) {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiApproval"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/Template");
//                                     } else {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiTemplate Management"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/MyTemplate");
//                                     }
//                                   }}
//                                   style={{
//                                     cursor: "pointer",
//                                   }}
//                                 >
//                                   <th scope="row" className="d-flex gap-2">
//                                     <Icon
//                                       className="text-white"
//                                       // class="d-block"
//                                       component="i"
//                                     >
//                                       newspaper_icon
//                                     </Icon>
//                                     <span classname="">Template</span>
//                                   </th>

//                                   <td>{data3?.templates}</td>
//                                 </div>
//                               </tbody>
//                             </table>
//                           </div>
//                         </div>
//                       </div>
//                     ) : null}

//                     {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//                     "ROLE_SUPER_ADMIN" ? (
//                       <>
//                         {(data5?.endTime && data5?.endTime !== 0) ||
//                         (data5?.startTime && data5?.startTime !== 0) ? (
//                           <div class="col-xl-3 col-md-6 my-3">
//                             <div
//                               class="card card_1 card_border_radius "
//                               style={{
//                                 background:
//                                   "linear-gradient(21deg, rgb(56 83 235 / 81%) 0%, rgb(164 159 219 / 66%) 35%, rgb(255, 255, 255) 100%)",
//                                 cursor: "default",
//                               }}
//                             >
//                               <div class="text-center d-flex justify-content-center ">
//                                 <div className="my-auto">
//                                   <h1 className="fs-4 my-auto ">Black Out</h1>
//                                 </div>
//                                 <div
//                                   class="div_i8  ms-3"
//                                   style={{
//                                     backgroundColor: "rgb(89 92 224 / 26%)",
//                                   }}
//                                 >
//                                   <Icon
//                                     sx={{
//                                       color: "rgb(89 92 224) !important",
//                                     }}
//                                     className="icon2_color_UP"
//                                     // class="d-block"
//                                     component="i"
//                                   >
//                                     notifications_off_icon
//                                   </Icon>
//                                 </div>

//                                 {/* <div>
//                           <h3>
//                             {data3?.senderIds?.toLocaleString("en-US")
//                               ? data3?.senderIds?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
                         
//                         </div> */}
//                               </div>
//                               <div className="mt-2">
//                                 <table class="table mb-0">
//                                   <tbody>
//                                     <div
//                                       className="border_transparent_up headingCard_up2 my-2"
//                                       style={{
//                                         cursor: "pointer",
//                                         background: "#1a05ebc9",
//                                       }}
//                                       onClick={() => {
//                                         localStorage.setItem(
//                                           "senderIdRedirectToken",
//                                           "0"
//                                         );
//                                         if (
//                                           JSON.parse(
//                                             localStorage.getItem("Sidebaritems")
//                                           )?.name == "ROLE_SUPER_ADMIN"
//                                         ) {
//                                           document
//                                             .getElementsByName(
//                                               "sidebarLiConfiguration"
//                                             )?.[0]
//                                             ?.click();
//                                           history?.push(
//                                             "/dashboard/BlackOutTime"
//                                           );
//                                         } else {
//                                         }
//                                       }}
//                                     >
//                                       <th scope="row" className="d-flex gap-2">
//                                         <Icon
//                                           className="text-white"
//                                           // class="d-block"
//                                           component="i"
//                                         >
//                                           watch_later_icon
//                                         </Icon>
//                                         <span className="">Start Time</span>
//                                       </th>
//                                       <td>{data5?.startTime}</td>
//                                     </div>

//                                     <div
//                                       className="border_transparent_up headingCard_up2 my-2"
//                                       style={{
//                                         cursor: "pointer",
//                                         background: "#1a05ebc9",
//                                       }}
//                                       onClick={() => {
//                                         localStorage.setItem(
//                                           "templateRedirectToken",
//                                           "0"
//                                         );
//                                         if (
//                                           JSON.parse(
//                                             localStorage.getItem("Sidebaritems")
//                                           )?.name == "ROLE_SUPER_ADMIN"
//                                         ) {
//                                           document
//                                             .getElementsByName(
//                                               "sidebarLiConfiguration"
//                                             )?.[0]
//                                             ?.click();
//                                           history?.push(
//                                             "/dashboard/BlackOutTime"
//                                           );
//                                         } else {
//                                         }
//                                       }}
//                                     >
//                                       <th scope="row" className="d-flex gap-2">
//                                         <Icon
//                                           className="text-white"
//                                           // class="d-block"
//                                           component="i"
//                                         >
//                                           watch_later_icon
//                                         </Icon>
//                                         <span className="">End Time</span>
//                                       </th>
//                                       <td>{data5?.endTime}</td>
//                                     </div>
//                                   </tbody>
//                                 </table>
//                               </div>
//                             </div>
//                           </div>
//                         ) : null}

//                         {data4?.tpsLimit && data4?.tpsLimit !== 0 ? (
//                           <div class="col-xl-3 col-md-6 my-3">
//                             <div
//                               class="card card_1 card_border_radius "
//                               style={{
//                                 height: "100%",
//                                 background:
//                                   "linear-gradient(21deg, rgb(255 0 0) 0%, rgb(255 60 60 / 63%) 35%, rgb(255, 255, 255) 100%)",
//                                 cursor: "default",
//                               }}
//                             >
//                               <div class="text-center d-flex justify-content-center ">
//                                 <div className="my-auto">
//                                   <h1 className="fs-4 my-auto ">TPS</h1>
//                                 </div>
//                                 <div
//                                   class="div_i8  ms-3"
//                                   style={{
//                                     backgroundColor: "rgb(255 0 0 / 25%)",
//                                   }}
//                                 >
//                                   <Icon
//                                     sx={{
//                                       color: "rgb(255 0 0 / 76%) !important",
//                                     }}
//                                     className="icon2_color_UP"
//                                     // class="d-block"
//                                     component="i"
//                                   >
//                                     schedule_send_icon
//                                   </Icon>
//                                 </div>
//                               </div>
//                               <div className="mt-2">
//                                 <table class="table mb-0">
//                                   <tbody>
//                                     <div
//                                       className="border_transparent_up headingCard_up2 my-2"
//                                       style={{
//                                         background: "#EB0505",
//                                         cursor: "pointer",
//                                       }}
//                                       onClick={() => {
//                                         localStorage.setItem(
//                                           "senderIdRedirectToken",
//                                           "0"
//                                         );
//                                         if (
//                                           JSON.parse(
//                                             localStorage.getItem("Sidebaritems")
//                                           )?.name == "ROLE_SUPER_ADMIN"
//                                         ) {
//                                           document
//                                             .getElementsByName(
//                                               "sidebarLiTps Control"
//                                             )?.[0]
//                                             ?.click();
//                                           history?.push("/dashboard/SystemTps");
//                                         } else {
//                                         }
//                                       }}
//                                     >
//                                       <th scope="row" className="d-flex gap-2">
//                                         <Icon
//                                           className="text-white"
//                                           // class="d-block"
//                                           component="i"
//                                         >
//                                           data_thresholding_icon
//                                         </Icon>
//                                         <span className="">TPS Limit</span>
//                                       </th>
//                                       <td>{data4?.tpsLimit}</td>
//                                     </div>

//                                     {/* <div
//                                   className="border_transparent_up headingCard_up2 my-2"
//                                   style={{
//                                     background: "#EB0505",
//                                     cursor: "pointer",
//                                   }}
//                                   onClick={() => {
//                                     localStorage.setItem(
//                                       "templateRedirectToken",
//                                       "0"
//                                     );
//                                     if (
//                                       JSON.parse(
//                                         localStorage.getItem("Sidebaritems")
//                                       )?.name == "ROLE_SUPER_ADMIN"
//                                     ) {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiApproval"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/Template");
//                                     } else {
//                                       document
//                                         .getElementsByName(
//                                           "sidebarLiTemplate Management"
//                                         )?.[0]
//                                         ?.click();
//                                       history?.push("/dashboard/MyTemplate");
//                                     }
//                                   }}
//                                 >
//                                   <th scope="row" className="d-flex gap-2">
//                                     <Icon
//                                       className="text-white"
//                                       // class="d-block"
//                                       component="i"
//                                     >
//                                       newspaper_icon
//                                     </Icon>
//                                     <span className="">Template</span>
//                                   </th>
//                                   <td>{data3?.pendingTemplate}</td>
//                                 </div> */}
//                                   </tbody>
//                                 </table>
//                               </div>
//                             </div>
//                           </div>
//                         ) : null}
//                       </>
//                     ) : null}
//                     {/* 
//                   <div
//                     class="col-xl-3 col-md-6 my-3 "
//                     onClick={() => {
//                       // if (dataTime.tabs == 0) {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Approved,template,${firstDay1},${lastDay1}`
//                       //   );
//                       // } else {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Approved,template,${firstDay},${lastDay}`
//                       //   );
//                       // }

//                       localStorage?.setItem(
//                         "dstQueCode1",
//                         `Approved,template,${
//                           dataTime.tabs == 0
//                             ? firstDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : firstDay0
//                         },${
//                           dataTime.tabs == 0
//                             ? lastDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : lastDay0
//                         }`
//                       );

//                       history?.push("/dashboard/Dashboardreports");
//                     }}
//                   >
//                     <div class="card card_1">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             newspaper_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3>
//                             {data3?.templates?.toLocaleString("en-US")
//                               ? data3?.templates?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
//                           <span>Approved Templates</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div
//                     class="col-xl-3 col-md-6 my-3"
//                     onClick={() => {
//                       // if (dataTime.tabs == 0) {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Pending,template,${firstDay1},${lastDay1}`
//                       //   );
//                       // } else {
//                       //   localStorage?.setItem(
//                       //     "dstQueCode1",
//                       //     `Pending,template,${firstDay},${lastDay}`
//                       //   );
//                       // }

//                       localStorage?.setItem(
//                         "dstQueCode1",
//                         `Pending,template,${
//                           dataTime.tabs == 0
//                             ? firstDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : firstDay0
//                         },${
//                           dataTime.tabs == 0
//                             ? lastDay11
//                             : dataTime.tabs == 3
//                             ? moment().format("YYYY-MM-DD")
//                             : dataTime.tabs == 4
//                             ? moment().add(-1, "day").format("YYYY-MM-DD")
//                             : lastDay0
//                         }`
//                       );

//                       history?.push("/dashboard/Dashboardreports");
//                     }}
//                   >
//                     <div class="card card_3">
//                       <div class="d-flex justify-content-between align-items-start">
//                         <div class="div_i8">
//                           <Icon
//                             // class="d-block"
//                             component="i"
//                           >
//                             newspaper_icon
//                           </Icon>
//                         </div>
//                         <div>
//                           <h3>
//                             {data3?.pendingTemplate?.toLocaleString("en-US")
//                               ? data3?.pendingTemplate?.toLocaleString("en-US")
//                               : "0"}
//                           </h3>
//                           <span>Pending Templates</span>
//                         </div>
//                       </div>
//                     </div>
//                   </div> */}
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         ) : null}

//         <div className="card mb-3">
//           <div className="card-header pb-0 p-3 pt-2">
//             <div className="d-flex justify-content-between px-2 mb-2">
//               <div className="my-auto">
//                 <span
//                   style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                   className="d-sm-inline ms_2 start_date_time_css"
//                 >
//                   {moment(dataTime?.dateTabs0.startdateValue)?.format(
//                     "DD-MMM-YYYY"
//                   )}
//                 </span>
//                 <ForwardIcon />
//                 <span
//                   style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                   className="d-sm-inline mx_2 start_date_time_css"
//                 >
//                   {moment(dataTime?.dateTabs0.enddateValue)?.format(
//                     "DD-MMM-YYYY"
//                   )}
//                 </span>
//               </div>
//               {/* <div className="my-2 text-end">
//               <span
//                 style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                 className="d-sm-inline ms_2 start_date_time_css"
//               >
//                 {selectedTime.start}
//               </span>
//               <ForwardIcon />
//               <span
//                 style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                 className="d-sm-inline mx_2 start_date_time_css"
//               >
//                 {selectedTime.end}
//               </span>

//               <IconButton
//                 variant="text"
//                 size="small"
//                 sx={{
//                   color: "rgba(0, 0, 0, 0.6)",
//                 }}
//                 // className="btn bg-gradient-primary "
//                 aria-describedby={
//                   Boolean(anchorEll) ? "simple-popover" : undefined
//                 }
//                 onClick={(event) => {
//                   setAnchorEll(event.currentTarget);
//                 }}
//               >
//                 <CalendarMonthIcon />
//               </IconButton>

//               <Popover
//                 id={Boolean(anchorEll) ? "simple-popover" : undefined}
//                 open={Boolean(anchorEll)}
//                 anchorEl={anchorEll}
//                 onClose={() => {
//                   setAnchorEll(null);
//                 }}
//                 anchorOrigin={{
//                   vertical: "bottom",
//                   horizontal: "left",
//                 }}
//                 transformOrigin={{
//                   vertical: "top",
//                   horizontal: "left",
//                 }}
//               >
//                 <DateRangePickerr />
//               </Popover>
//             </div> */}

//               <div className="my-auto">
//                 <div class="datePickerButtonsDashboard">
//                   {[
//                     {
//                       name: "1D",
//                       startdateValue: moment().format("YYYY-MM-DD"),
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       dateTypee: "Daily",
//                       tooltipText: "1 Day",
//                     },
//                     // {
//                     //   name: "Yesterday",
//                     //   startdateValue: "",
//                     //   enddateValue: "",
//                     // },
//                     {
//                       name: "1W",
//                       startdateValue: moment(addDays(new Date(), -7)).format(
//                         "YYYY-MM-DD"
//                       ),
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       dateTypee: "Daily",
//                       tooltipText: "1 Week",
//                     },
//                     {
//                       name: "1M",
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       startdateValue: moment(addDays(new Date(), -29)).format(
//                         "YYYY-MM-DD"
//                       ),
//                       dateTypee: "Month",
//                       startDateMonth: moment(
//                         startOfMonth(addMonths(new Date(), -1))
//                       ).format("YYYYMM"),
//                       endDateMonth: moment().format("YYYYMM"),
//                       tooltipText: "1 Month",
//                     },
//                     {
//                       name: "3M",
//                       startdateValue: moment(addMonths(new Date(), -3)).format(
//                         "YYYY-MM-DD"
//                       ),
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       dateTypee: "Monthly",
//                       tooltipText: "3 Months",
//                     },
//                     {
//                       name: "6M",
//                       startdateValue: moment(addMonths(new Date(), -6)).format(
//                         "YYYY-MM-DD"
//                       ),
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       dateTypee: "Monthly",
//                       tooltipText: "6 Months",
//                     },
//                   ].map((dataaa, index) => {
//                     return (
//                       <a
//                         data-bs-toggle="tooltip"
//                         data-bs-placement="top"
//                         title={dataaa.tooltipText}
//                         onClick={() => {
//                           seDataTime({
//                             ...dataTime,
//                             dateTabs0: dataaa,
//                           });
//                         }}
//                         className={
//                           dataTime.dateTabs0.name === dataaa.name
//                             ? "active"
//                             : ""
//                         }
//                       >
//                         {" "}
//                         {dataaa.name}
//                       </a>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>

//             <div class="row mb-4">
//               {/* <DateRangePickerr /> */}
//               <div class="col-md-6">
//                 <div class="card bar_card">
//                   <div class="row mb-3">
//                     <div class="col-md-9">
//                       {/* <h6 class="user">User account vs spam manager</h6> */}
//                       <h6 class="user">Number of Messages</h6>
//                     </div>

//                     <div class="col-md-3 ">
//                       <FormControl fullWidth>
//                         <InputLabel size="small" id="demo-simple-select-label">
//                           Show by
//                         </InputLabel>
//                         <Select
//                           size="small"
//                           labelId="demo-simple-select-label"
//                           id="demo-simple-select"
//                           value={dataTime.graph1}
//                           label="Show by"
//                           onChange={(e) => {
//                             seDataTime({
//                               ...dataTime,
//                               graph1: e.target.value,
//                             });
//                           }}
//                         >
//                           <MenuItem value="Monthly">Month</MenuItem>
//                           {/* <MenuItem value="Weeks">Week</MenuItem> */}
//                           {/* {selectedTime?.dateType != "Monthly" && ( */}
//                           <MenuItem value="Daily">Date</MenuItem>
//                           {/* )} */}
//                         </Select>
//                       </FormControl>
//                     </div>
//                   </div>
//                   <div class="border_btm"></div>
//                   {/* <img class="img-fluid" src={g7} alt="" /> */}
//                   <MultiGraph value={dataTime.graph1} />
//                   {/* <MultiGraph /> */}
//                 </div>
//               </div>

//               <div class="col-md-6"  >
//                 <div class="card bar_card">
//                   <div class="row mb-3">
//                     <div class="col-md-9">
//                       <h6 class="user">Campaigns</h6>
//                     </div>

//                     <div class="col-md-3">
//                       <div className="w-100">
//                         <FormControl fullWidth>
//                           <InputLabel
//                             size="small"
//                             id="demo-simple-select-label"
//                           >
//                             Show by
//                           </InputLabel>
//                           <Select
//                             size="small"
//                             labelId="demo-simple-select-label"
//                             id="demo-simple-select"
//                             value={dataTime.line1}
//                             label="Show by"
//                             onChange={(e) => {
//                               seDataTime({
//                                 ...dataTime,
//                                 line1: e.target.value,
//                               });
//                             }}
//                           >
//                             <MenuItem value="Monthly">Month</MenuItem>

//                             <MenuItem value="Daily">Date</MenuItem>
//                           </Select>
//                         </FormControl>
//                       </div>
//                     </div>

//                     <div  ref={downloadRef_revenuecost} id="revenucostgraphFull" style={{background: "white"}}>

                 
//                     {isFullScreen ? (
//                           <>
//                             <div className="d-flex align-items-center" style={{flex:'0 0 auto'}}>
                           
//                               <CancelIcon onClick={exitFullScreen} />
//                             </div>
//                           </>
//                         ) : (
                    
//                        <>

//                        </>
//                         )}
//                         {

//                        !isFullScreen? (
//                      <div class="d-flex justify-content-between align-items-center mb-3">
//                                   <>
//                                     {" "}
//                                     <IconButton
//                                       aria-label="more"
//                                       id="long-button"
//                                       aria-controls={
//                                         openmenue4 ? "long-menu" : undefined
//                                       }
//                                       aria-expanded={
//                                         openmenue4 ? "true" : undefined
//                                       }
//                                       aria-haspopup="true"
//                                       onClick={handleClickmenue4}
//                                     >
//                                       <MoreVertIcon />
//                                     </IconButton>
//                                   </>
//                                 <Menu
//                                   id="long-menu"
//                                   MenuListProps={{
//                                     "aria-labelledby": "long-button",
//                                   }}
//                                   style={{ zIndex: "9999999999" }}
//                                   anchorEl={anchorEl4}
//                                   open={openmenue4}
//                                   onClose={handleClosemenue4}
//                                   PaperProps={{
//                                     style: {
//                                       width: "auto",
//                                     },
//                                   }}
//                                   transformOrigin={{
//                                     horizontal: "right",
//                                     vertical: "top",
//                                   }}
//                                   anchorOrigin={{
//                                     horizontal: "right",
//                                     vertical: "bottom",
//                                   }}
//                                 >
//                                   <MenuItem
//                                     onClick={handleClickExcel_revenucostDATA}
//                                   >
                             
//                                     <DescriptionIcon style={{color:"Green", width:'1em !important', height:'1em !important'}} />
//                                     Data in Excel
//                                   </MenuItem>

//                                   <MenuItem
//                                     onClick={
                                    
//                                         downloadChartAsPDF_revenucostDATA
//                                     }
//                                   >
//                                     <PictureAsPdfIcon style={{color:"Red", width:'1em !important', height:'1em !important'}}/>
//                                     Data in PDF
//                                   </MenuItem>

//                                   <MenuItem onClick={enterFullScreen}>
//                                   <AssessmentIcon style={{color:"#2191d0", width:'1em !important', height:'1em !important'}}/>
//                                     View Full{" "}
//                                     {ViewTableForm == true
//                                       ? "Table"
//                                       : "Graph  "}
                                      
//                                   </MenuItem>
//                                 </Menu>
//                               </div>
//                         ):null}

//                   <div class=""  style={{background: "white"}}>
//                   <MultiLineGraph value={dataTime.line1} />
//                   </div>
//                   </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div class="row mb-4">
//               <div class="col-md-3">
//                 <div class="card min_height">
//                   <div class="row mt-2 mb-2">
//                     <div class="col-md-12">
//                       <h6 class="super">Templates</h6>
//                     </div>
//                   </div>

//                   <div class="border_btm"></div>
//                   <DoughnutGraph
//                     value={dataTime.pie1}
//                     api={"sms/dashboard/v1/get/template/pie-chart"}
//                   />
//                 </div>
//               </div>
//               <div class="col-md-3">
//                 <div class="card min_height">
//                   <div class="row mt-2 mb-2">
//                     <div class="col-md-12">
//                       <h6 class="super">Sender Ids</h6>
//                     </div>
//                     {/* <div class="col-md-6 col_6">
//                     <div>
//                       <FormControl fullWidth>
//                         <InputLabel size="small" id="demo-simple-select-label">
//                           Show by
//                         </InputLabel>
//                         <Select
//                           size="small"
//                           labelId="demo-simple-select-label"
//                           id="demo-simple-select"
//                           value={dataTime.pie1}
//                           label="Show by"
//                           onChange={(e) => {
//                             seDataTime({
//                               ...dataTime,
//                               pie1: e.target.value,
//                             });
//                           }}
//                         >
//                           <MenuItem value="Month">Month</MenuItem>
//                           <MenuItem value="Weeks">Weeks</MenuItem>
//                           <MenuItem value="Days">Days</MenuItem>
//                         </Select>
//                       </FormControl>
//                     </div>
//                   </div> */}
//                   </div>

//                   <div class="border_btm"></div>
//                   <DoughnutGraph
//                     value={dataTime.pie1}
//                     api={"sms/dashboard/v1/get/sender-id/pie-chart"}
//                   />
//                 </div>
//               </div>

//               {/* <div class="col-md-3">
//                 <div class="card min_height">
//                   <div class="row mt-2  mb-3">
//                     <div class="col-md-12">
//                       <h6 class="super">SMS Push(Total : 6616)</h6>
//                     </div>
                 
//                   </div>

//                   <div class="border_btm"></div>
//                   <PieGraph value={dataTime.pie2} />
//                 </div>
//               </div> */}

//               {/* <div class="col-md-3">
//                 <div class="card min_height">
//                   <div class="row mt-2  mb-2">
//                     <div class="col-md-12">
//                       <h6 class="super">Recharges</h6>
//                     </div>
//                   </div>

//                   <div class="border_btm"></div>
//                   <DoughnutGraph
//                     value={dataTime.pie1}
//                     api={"sms/dashboard/v1/get/recharge/pie-chart"}
//                   />
//                 </div>
//               </div> */}

//               <div class="col-md-3">
//                 {/* <Link to={`/dashboard/CampaignsControl`}> */}
//                 <div class="card bar_card bar_card_8" id="bar_card">
//                   <div class="row">
//                     <div class="col-md-12 mb-2">
//                       <h6 class="user p-0">Campaign</h6>
//                     </div>
//                     <div class="border_btm"></div>
//                   </div>
//                   <ProgressBar
//                     value={dataTime.progress1}
//                     lastDay={lastDay}
//                     firstDay={firstDay}
//                   />
//                 </div>
//                 {/* </Link> */}
//               </div>

//               {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//               "ROLE_SUPER_ADMIN" ? (
//                 <>
//                   <div class="col-md-3">
//                     <div
//                       class="card bar_card bar_card_8 card_height_up"
//                       id="bar_card1"
//                     >
//                       <div class="row">
//                         <div class="col-md-12 mb-2">
//                           <h6 class="user p-0">Top Sender Ids</h6>
//                         </div>
//                         <div class="border_btm"></div>
//                       </div>

//                       <UserProgressBar
//                         type="senderId"
//                         topSenderIdData={data6}
//                         topSenderIdOpen={open6}
//                       />
//                     </div>

//                     <div
//                       class="card bar_card bar_card_8 card_height_up mb-0"
//                       id="bar_card1"
//                     >
//                       <div class="row mt-2">
//                         <div class="col-md-12 mb-2">
//                           <h6 class="user p-0">Top Users</h6>
//                         </div>
//                         <div class="border_btm"></div>
//                       </div>

//                       <UserProgressBar
//                         type="user"
//                         topSenderIdData={data6}
//                         topSenderIdOpen={open6}
//                       />
//                     </div>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div class="col-md-3">
//                     <div class="card bar_card bar_card_8 " id="bar_card1">
//                       <div class="row">
//                         <div class="col-md-12 mb-2">
//                           <h6 class="user p-0">Top Sender Ids</h6>
//                         </div>
//                         <div class="border_btm"></div>
//                       </div>

//                       <UserProgressBar
//                         type="senderId"
//                         topSenderIdData={data6}
//                         topSenderIdOpen={open6}
//                       />
//                     </div>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="card mb-3">
//           <div className="card-header p-3 py-4" id="stats">
//             {/* <div class="container-fluid py-3"> */}

//             <div className="d-flex justify-content-between px-2 mb-2">
//               <div className="my-auto">
//                 <span
//                   style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                   className="d-sm-inline ms_2 start_date_time_css"
//                 >
//                   {moment(dataTime?.dateTabs1.startdateValue)?.format(
//                     "DD-MMM-YYYY"
//                   )}
//                 </span>
//                 <ForwardIcon />
//                 <span
//                   style={{ backgroundColor: "#3c8dbc", color: "white" }}
//                   className="d-sm-inline mx_2 start_date_time_css"
//                 >
//                   {moment(dataTime?.dateTabs1.enddateValue)?.format(
//                     "DD-MMM-YYYY"
//                   )}
//                 </span>
//               </div>

//               <div className="my-auto">
//                 <div class="datePickerButtonsDashboard">
//                   {[
//                     {
//                       name: "1D",
//                       startdateValue: moment().format("YYYY-MM-DD"),
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       dateTypee: "Days",
//                       tooltipText: "1 Day",
//                     },
//                     // {
//                     //   name: "Yesterday",
//                     //   startdateValue: "",
//                     //   enddateValue: "",
//                     // },
//                     {
//                       name: "1W",
//                       startdateValue: moment(addDays(new Date(), -7)).format(
//                         "YYYY-MM-DD"
//                       ),
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       dateTypee: "Days",
//                       tooltipText: "1 Week",
//                     },
//                     {
//                       name: "1M",
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       startdateValue: moment(addDays(new Date(), -29)).format(
//                         "YYYY-MM-DD"
//                       ),
//                       dateTypee: "Month",
//                       startDateMonth: moment(
//                         startOfMonth(addMonths(new Date(), -1))
//                       ).format("YYYYMM"),
//                       endDateMonth: moment().format("YYYYMM"),
//                       tooltipText: "1 Month",
//                     },
//                     {
//                       name: "3M",
//                       startdateValue: moment(addMonths(new Date(), -3)).format(
//                         "YYYY-MM-DD"
//                       ),
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       dateTypee: "Month",
//                       startDateMonth: moment(addMonths(new Date(), -3)).format(
//                         "YYYYMM"
//                       ),
//                       endDateMonth: moment().format("YYYYMM"),
//                       tooltipText: "3 Months",
//                     },
//                     {
//                       name: "6M",
//                       startdateValue: moment(addMonths(new Date(), -6)).format(
//                         "YYYY-MM-DD"
//                       ),
//                       enddateValue: moment().format("YYYY-MM-DD"),
//                       dateTypee: "Month",
//                       startDateMonth: moment(addMonths(new Date(), -5)).format(
//                         "YYYYMM"
//                       ),
//                       endDateMonth: moment().format("YYYYMM"),
//                       tooltipText: "6 Months",
//                     },
//                   ].map((dataaa, index) => {
//                     return (
//                       <a
//                         data-bs-toggle="tooltip"
//                         data-bs-placement="top"
//                         title={dataaa.tooltipText}
//                         onClick={() => {
//                           seDataTime({
//                             ...dataTime,
//                             dateTabs1: dataaa,
//                           });
//                         }}
//                         className={
//                           dataTime.dateTabs1.name === dataaa.name
//                             ? "active"
//                             : ""
//                         }
//                       >
//                         {" "}
//                         {dataaa.name}
//                       </a>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>

//             <section
//               class="card p-3"
//               id="chnnel_8"
//               ref={ref}
//               // style={{
//               //   display: isVisible ? "block" : "none",
//               // }}
//             >
//               {isVisible ? (
//                 <div>
//                   <h4 class="text-capitalize m-0">all channels performance</h4>
//                   <div class="row mt-4">
//                     {open1 ? (
//                       <>
//                         <div class="col-md-4">
//                           <Skeleton variant="rectangular" height={218} />
//                         </div>
//                         <div class="col-md-4">
//                           <Skeleton variant="rectangular" height={218} />
//                         </div>
//                         <div class="col-md-4">
//                           <Skeleton variant="rectangular" height={218} />
//                         </div>
//                       </>
//                     ) : (
//                       <>
//                         <div class="col-md-4">
//                           <div class="d-flex align-items-center box">
//                             <div class="w-100 text-center text-capitalize">
//                               <Icon
//                                 style={{ fontSize: "36px", color: "green" }}
//                                 // class="d-block"
//                                 component="i"
//                               >
//                                 mark_email_read_icon
//                               </Icon>
//                               <h1 class="m-0 my-1">
//                                 <Counter
//                                   data={{
//                                     id: "002",
//                                     label: "Ice Cream Flavors",
//                                     number:
//                                       data1?.totalMessage !== null &&
//                                       !isNaN(data1?.totalMessage)
//                                         ? `${data1?.totalMessage?.toLocaleString(
//                                             "en-US"
//                                           )}`
//                                         : "0",
//                                     duration: "2",
//                                   }}
//                                 />
//                               </h1>
//                               <p class="mt-">messages</p>
//                             </div>
//                           </div>
//                         </div>
//                         <div class="col-md-4 my_4">
//                           <div class="d-flex align-items-center box">
//                             <div class="w-100 text-center text-capitalize">
//                               <Icon
//                                 style={{ fontSize: "36px", color: "green" }}
//                                 // class="d-block"
//                                 component="i"
//                               >
//                                 trending_up_icon
//                               </Icon>
//                               <h1 class="m-0 my-1">
//                                 <Counter
//                                   data={{
//                                     id: "002",
//                                     label: "Ice Cream Flavors",
//                                     number:
//                                       data1?.percentage !== null &&
//                                       !isNaN(data1?.percentage)
//                                         ? `${`${data1?.percentage}`?.substring(
//                                             0,
//                                             `${data1?.percentage}`?.split(
//                                               "."
//                                             )?.[0]?.length
//                                           )}`
//                                         : "0",
//                                     duration: "2",
//                                   }}
//                                 />
//                                 {`${data1?.percentage}`
//                                   ?.split(".")[1]
//                                   ?.substring(0, 2) ? (
//                                   <>
//                                     .
//                                     {`${data1?.percentage}`
//                                       ?.split(".")[1]
//                                       ?.substring(0, 2)}
//                                   </>
//                                 ) : null}
//                                 %
//                               </h1>
//                               <p class="mt-">Delivery Rate</p>
//                             </div>
//                           </div>
//                         </div>
//                         <div class="col-md-4">
//                           <div class="d-flex align-items-center box">
//                             <div class="w-100 text-center text-capitalize">
//                               <Icon
//                                 style={{ fontSize: "36px", color: "green" }}
//                                 // class="d-block"
//                                 component="i"
//                               >
//                                 credit_score_icon
//                               </Icon>
//                               <h1 class="m-0 my-1">
//                                 {isNaN(data1?.totalCredit)
//                                   ? Number("0")?.toLocaleString("en-US")
//                                   : Number(data1?.totalCredit)?.toLocaleString(
//                                       "en-US"
//                                     )}
//                               </h1>
//                               <p class="mt-">Used Credit</p>
//                             </div>
//                           </div>
//                         </div>
//                       </>
//                     )}
//                   </div>
//                 </div>
//               ) : null}
//             </section>

//             <section class="card p-3 mt-4" id="status_8">
//               <h4 class="text-capitalize m-0">Breakdown by Status</h4>
//               <div class="row mt-3">
//                 {open2 ? (
//                   <>
//                     <div class="col-1 new_width">
//                       <Skeleton variant="rectangular" height={200} />
//                     </div>
//                     <div class="col-1 new_width">
//                       <Skeleton variant="rectangular" height={200} />
//                     </div>
//                     <div class="col-1 new_width">
//                       <Skeleton variant="rectangular" height={200} />
//                     </div>
//                     <div class="col-1 new_width">
//                       <Skeleton variant="rectangular" height={200} />
//                     </div>
//                     <div class="col-1 new_width">
//                       <Skeleton variant="rectangular" height={200} />
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div class="col-1 new_width">
//                       <div class="d-flex align-items-center box bg_1">
//                         <div class="w-100 text-center text-capitalize">
//                           <h1 class="m-0">
//                             <CircularStatic
//                               value={
//                                 data2?.delivered !== null
//                                   ? data2?.delivered
//                                   : 82
//                               }
//                               color={"white"}
//                             />
//                           </h1>
//                           <p class="text-capitalize mt-1">delivered</p>
//                         </div>
//                       </div>
//                     </div>
//                     <div class="col-1 new_width my_4">
//                       <div class="d-flex align-items-center box bg_2">
//                         <div class="w-100 text-center text-capitalize">
//                           <h1 class="m-0">
//                             {" "}
//                             <CircularStatic
//                               value={
//                                 data2?.rejected !== null ? data2?.rejected : 82
//                               }
//                               color={"white"}
//                             />
//                           </h1>
//                           <p class="text-capitalize mt-1">failed</p>
//                         </div>
//                       </div>
//                     </div>
//                     <div class="col-1 new_width">
//                       <div class="d-flex align-items-center box bg_3">
//                         <div class="w-100 text-center text-capitalize">
//                           <h1 class="m-0">
//                             {" "}
//                             <CircularStatic
//                               value={
//                                 data2?.pending !== null ? data2?.pending : 82
//                               }
//                               color={"white"}
//                             />
//                           </h1>
//                           <p class="text-capitalize mt-1">pending</p>
//                         </div>
//                       </div>
//                     </div>
//                     <div class="col-1 new_width my_4">
//                       <div class="d-flex align-items-center box bg_4">
//                         <div class="w-100 text-center text-capitalize">
//                           <h1 class="m-0">
//                             {" "}
//                             <CircularStatic
//                               value={
//                                 data2?.expired !== null ? data2?.expired : 82
//                               }
//                               color={"white"}
//                             />
//                           </h1>
//                           <p class="text-capitalize mt-1">expired</p>
//                         </div>
//                       </div>
//                     </div>
//                     <div class="col-1 new_width">
//                       <div class="d-flex align-items-center box bg_5">
//                         <div class="w-100 text-center text-capitalize">
//                           <h1 class="m-0">
//                             {" "}
//                             <CircularStatic
//                               value={
//                                 data2?.unDelivered !== null
//                                   ? data2?.unDelivered
//                                   : 82
//                               }
//                               color={"white"}
//                             />
//                           </h1>
//                           <p class="text-capitalize mt-1">undelivered</p>
//                         </div>
//                       </div>
//                     </div>
//                   </>
//                 )}
//               </div>
//             </section>
//             {/* </div> */}
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// }
